import { AccessGuids, AlertClassColour, ConfigSystemParams, DgActionColumnWidth, DgColumnDataType, DgColumnWidths, eSimApiPaths, GridViewTitles, msSize, OurColors } from 'src/app/core/consts';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AlertCountryCoverageComponent } from '../alert-country-coverage/alert-country-coverage.component';
import { AlertCountryDTO } from 'src/app/core/models/system/alert/alertCountry.dto';
import { AlertCountryGroupDTO } from 'src/app/core/models/system/alert/alertCountryGroup.dto';
import { AlertDTO } from 'src/app/core/models/system/alert/alert.dto';
import { AlertDeviceDTO } from 'src/app/core/models/system/alert/alertDevice.dto';
import { AlertGroupDTO } from 'src/app/core/models/system/alert/alertGroup.dto';
import { AlertsService } from 'src/app/core/services/utelize/system/alert/alerts-service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, defer, firstValueFrom, forkJoin, lastValueFrom, Observable, throwError } from 'rxjs';
import { CommConfigDTO } from 'src/app/core/models/system/communication/comm-config.dto';
import { CommConfigService } from 'src/app/core/services/utelize/system/communication/comm-config-service';
import { CommunicationTemplateDTO } from 'src/app/core/models/system/communication/communication-template.dto';
import { CommunicationTemplateReplacements } from 'src/app/core/models/system/communication/communication-template-replacements';
import { CommunicationTemplatesDefaultsDTO } from 'src/app/core/models/system/communication/communication-templates-defaults.dto';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompanyDTO } from 'src/app/core/models/system/company/company.dto';
import { CompanyModalFormComponent } from '../_company/company-modal-form/company-modal-form.component';
import { CompletedModalFormComponent } from 'src/app/forms-modal/_pop-ups/completed-modal-form/completed-modal-form.component';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ConfirmationModalFormComponent } from "../_pop-ups/confirmation-modal-form/confirmation-modal-form.component";
import { DeliveryType, MessageType, MessageTypeText, TemplateModalAction } from 'src/app/core/enums';
import { DevicesService } from 'src/app/core/services/utelize/system/device/devices-service';
import { DgActionColumn } from 'src/app/core/interfaces/datagrid/dg-action-column';
import { DgApiPath } from 'src/app/core/interfaces/datagrid/dg-api-paths';
import { DgColumn } from 'src/app/core/interfaces/datagrid/dg-column';
import { DgPopup } from 'src/app/core/interfaces/datagrid/dg-pop-up';
import { DgProperties } from 'src/app/core/interfaces/datagrid/dg-properties';
import { DgTab } from 'src/app/core/interfaces/datagrid/dg-tab';
import { EncryptionService } from 'src/app/core/services/utelize/general/encryption-service';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { GridViewComponent } from 'src/app/core/grid-view/component/grid-view.component';
import { GridViewDefaults } from 'src/app/core/grid-view/component/grid-view.defaults';
import { GridViewService } from 'src/app/core/services/utelize/general/grid-view.service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { InputModalFormComponent } from 'src/app/forms-modal/_inputs/input-form/input-modal-form.component';
import { InviewUserDTO } from 'src/app/core/models/inview/inview-user.dto';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { ModalForceCloseService } from 'src/app/core/services/utelize/general/modal-force-close-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PageCompHeaderComponent } from "src/app/core/page-components/page-comp-header/page-comp-header.component";
import { ProductsService } from 'src/app/core/services/utelize/system/product/products-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TemplateEmailModalFormComponent } from 'src/app/forms-modal/template-email-modal-form/template-email-modal-form.component';
import { TemplateNotificationModalFormComponent } from 'src/app/forms-modal/template-notification-modal-form/template-notification-modal-form.component';
import { TemplateSMSModalFormComponent } from 'src/app/forms-modal/template-sms-modal-form/template-sms-modal-form.component';
import { UserGroupAllocationDTO } from 'src/app/core/models/system/user-group/user-group-allocation.dto';
import { UserGroupDTO } from 'src/app/core/models/system/user-group/user-group.dto';
import { UserGroupService } from 'src/app/core/services/utelize/system/user-group/user-group-service';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

const apiPath             =environment.eSimApi+eSimApiPaths.Alerts+"/"+eSimApiPaths.AlertsGetDevices;
const apiPathCountry      =environment.eSimApi+eSimApiPaths.Alerts+"/"+eSimApiPaths.AlertsGetCountries;
const apiPathCountryGroup =environment.eSimApi+eSimApiPaths.CountryGroups+"/"+eSimApiPaths.CountryGroupsGetAllGroupsForAlert;
const apiPathGroup        =environment.eSimApi+eSimApiPaths.UserGroups+"/"+eSimApiPaths.UserGroupsGetAllGroupsForAlertId;
const exportFilenameSuffix="Alert-Details";
const mainTitle           =GridViewTitles.alertDetails;
const popUpTitle          =GridViewTitles.alertDetails;

@Component({
  selector: 'app-alert-modal-edit-form',
  templateUrl: './alert-modal-edit-form.component.html',
  styleUrls: ['./alert-modal-edit-form.component.scss'],
  providers: [GridViewService]
  //encapsulation: ViewEncapsulation.None
})

export class AlertModalEditFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Input() embeddedFormMode      : boolean | undefined;
  @Input() initialCompanyId      : number  | undefined;
  @Input() initialInviewCompanyId: number  | undefined;

  @Output() alertFormCancelled   : EventEmitter<void> = new EventEmitter<void>();
  @Output() alertDataHasBeenSaved: EventEmitter<any>  = new EventEmitter<any>();
  
  @ViewChild('alertModalFormContent',        { static: false }) alertModalFormContent!         : TemplateRef<void>;
  @ViewChild('companyModalForm',             { static: false }) companyModalForm!              : CompanyModalFormComponent;
  @ViewChild('completedModalForm',           { static: false }) completedModalForm!            : CompletedModalFormComponent;
  @ViewChild('countryCoverage',              { static: false }) countryCoverage!               : AlertCountryCoverageComponent;
  @ViewChild('emailTemplateModalForm',       { static: false }) emailTemplateModalForm!        : TemplateEmailModalFormComponent;
  @ViewChild('gridView'                  ,   { static: false }) gridView!                      : GridViewComponent;
  @ViewChild('gridViewCountries'         ,   { static: false }) gridViewCountries!             : GridViewComponent;
  @ViewChild('gridViewCountryGroups',        { static: false }) gridViewCountryGroups!         : GridViewComponent;
  @ViewChild('gridViewGroups',               { static: false }) gridViewGroups!                : GridViewComponent;
  @ViewChild('inputModalForm',               { static: false }) inputModalForm!                : InputModalFormComponent;
  //@ViewChild('manageEsimModalForm',          { static: false }) manageEsimModalForm!           : ManageEsimModalFormComponent;
  @ViewChild('notificationTemplateModalForm',{ static: false }) notificationTemplateModalForm! : TemplateNotificationModalFormComponent;
  //@ViewChild('pageHeader',                   { static: false }) pageHeader!                    : PageCompHeaderComponent;
  @ViewChild(PageCompHeaderComponent                          ) pageHeader!                    : PageCompHeaderComponent;
  @ViewChild('reassignConfirmationModal',    { static: false }) reassignConfirmationModal!     : ConfirmationModalFormComponent;
  @ViewChild('smsTemplateModalForm',         { static: false }) smsTemplateModalForm!          : TemplateSMSModalFormComponent;
  //@ViewChild('userModalForm',                { static: false }) userModalForm!                 : UserModalFormComponent;
  @ViewChild('warningModalForm',             { static: false }) warningModalForm!              : WarningModalFormComponent;
  
  get currentAlert         () { return this.alert                                ; }
  get companyCurrencySymbol() { return this.company?.invoiceCurrencySymbol ?? "£"; }

  get AlertingShowAdminSwitches() { return this.componentAccessUserService.hasAccessGuid(AccessGuids.FormAlertAdminSwitches); }
  
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false     ) }

  get AlertingHidePWA      () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.AlertingHidePWA, true); }
  get showTestMessageButton() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.CommunicationTemplatesShowTestMessageButton, true); }
  get showUserGroups       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowUserGroups,                              true); }

  private alert                    : AlertDTO | undefined;
  private alertDevices             : AlertDeviceDTO[] = [];
  private alertModalFormRef!       : NgbModalRef;
  private alertSavedMessage        : string="Changes applied.";
  private alertTemplateId          : number=0;
  private alertTypeIdData!         : IdAndDescriptionDTO[];
  private company                  : CompanyDTO | undefined;
  private curUser                  : SystemUserDTO;
  private DoNotCloseFormOnCompleted: boolean=false;
  private gridViewDefaults!        : GridViewDefaults;
  private initialInviewCompanyIdSet: boolean=false;
  private initialStatus            : string="Please complete the following details";
  private inviewCompanyIdData!     : IdAndDescriptionDTO[];
  private inviewUserIdData!        : InviewUserDTO[];
  private isModalOpen              : boolean = false;
  private productIdData!           : IdAndDescriptionDTO[];
  private sureSimUserId            : number | undefined;
  private throttleSpeedIdData!     : IdAndDescriptionDTO[];
 
  public activeId                      : number = 1;
  public activeIdCountry               : number = 1;
  public activeIdCountryGroup          : number = 1;
  public activeIdUserGroup             : number = 1;
  public addOnCompanyCreation          : boolean=false;
  public addUserButtonEnabled          : boolean=false;
  public alertColourOrderStatus        : string=AlertClassColour.Grey;
  public alertColourProgress           : string=AlertClassColour.Grey;
  public alertFilterApplied            : boolean=false;
  public alertCountryFilterApplied     : boolean=false;
  public alertCountryGroupFilterApplied: boolean=false;
  public alertGroupFilterApplied       : boolean=false;
  public alertForm!                    : UntypedFormGroup;
  public alertGroupId                  : number=1;
  public alertId                       : number=0;
  public breadCrumbItems!              : Array<{}>;
  public commConfigs                   : CommConfigDTO[] = [];
  public commConfigsMain               : CommConfigDTO | undefined;
  public commTemplates                 : CommunicationTemplateDTO[] = [];
  public companyDefaults!              : CommunicationTemplatesDefaultsDTO;
  public defaultOpen                   : boolean = false;
  public defaultTemplate               : boolean = false;
  public dgApiPath!                    : DgApiPath | undefined;
  public dgApiPathCountries!           : DgApiPath | undefined;
  public dgApiPathCountryGroups!       : DgApiPath | undefined;
  public dgApiPathGroups!              : DgApiPath | undefined;
  public dgActionColumn!               : DgActionColumn | undefined;
  public dgActionColumnCountries!      : DgActionColumn | undefined;
  public dgActionColumnCountryGroups!  : DgActionColumn | undefined;
  public dgActionColumnGroups!         : DgActionColumn | undefined;
  public dgColumns!                    : Array<DgColumn>;
  public dgColumnsCountries!           : Array<DgColumn>;
  public dgColumnsCountryGroups!       : Array<DgColumn>;
  public dgColumnsGroups!              : Array<DgColumn>;
  public dgPopup!                      : DgPopup | undefined;
  public dgPopupCountries!             : DgPopup | undefined;
  public dgPopupCountryGroups!         : DgPopup | undefined;
  public dgPopupGroups!                : DgPopup | undefined;
  public dgProperties!                 : DgProperties | undefined;
  public dgPropertiesCountries!        : DgProperties | undefined;
  public dgPropertiesCountryGroups!    : DgProperties | undefined;
  public dgPropertiesGroups!           : DgProperties | undefined;
  public dgTabs!                       : Array<DgTab>;
  public dgTabsCountries!              : Array<DgTab>;
  public dgTabsCountryGroups!          : Array<DgTab>;
  public dgTabsGroups!                 : Array<DgTab>;

  public disableAddOnCompanyCreation   : boolean = false;
  public disableTemplate               : boolean = false;
  public dropDownStatus                : any = {};
  public emailTemplates                : CommunicationTemplateDTO[] = [];
  public filterCompanyID               : number = -1;
  public formSubmitted                 : boolean=false;
  public formTitle                     : string="Alert Details";
  public inviewCompanyId               : number | undefined;
  public messageTypeId                 : number = MessageType.Alert;
  public notificationTemplates         : CommunicationTemplateDTO[] = [];
  public planId                        : number = 1;
  public provisionButtonEnabled        : boolean=false;
  public progressInformation           : string=this.initialStatus;
  public reassignCountryData           : any;
  public selectedAlertTypeId           : number | undefined = undefined;
  public selectedEmailTemplateId       : number | undefined = undefined;
  public selectedEmailTemplate         : CommunicationTemplateDTO | undefined;
  public selectedNotificationTemplateId: number | undefined = undefined;
  public selectedNotificationTemplate  : CommunicationTemplateDTO | undefined;
  public selectedSMSTemplateId         : number | undefined = undefined;
  public selectedSMSTemplate           : CommunicationTemplateDTO | undefined;
  public smsTemplates                  : CommunicationTemplateDTO[] = [];
  public submitButtonEnabled           : boolean=true;
  public sureSimCompanyId              : number | undefined;
  public templateButtonsEnabled        : boolean = false;
  public templateOpen                  : boolean = false;
  public templateReplacements          : CommunicationTemplateReplacements[] = [];
  public templateTestInProgress        : boolean = false;
  public userGroupAllocations          : UserGroupAllocationDTO[] = [];
  public userGroupGroupFilterApplied   : boolean=false;
  public userGroups                    : UserGroupDTO[] = [];
  public userSimValues                 : IdAndDescriptionDTO[] = [];
  public warningMessageMain            : string | undefined;
  public warningMessageSub             : string | undefined;

  //#region for Validators
  
  public nameMaxLength: number=100;
  
  //#endregion 

  //#region NavItems
 
  public navItemLog_OptedIn : number=1;
  public navItemLog_OptedOut: number=2;
  
  public navItemLog_Included     : number=1;
  public navItemLog_Available    : number=2;
  public navItemLog_UsedElsewhere: number=3;

  public navItemLog_Group_Included: number=1;
  public navItemLog_Group_Excluded: number=2;

  public navItemLog_CountryGroup_Included: number=1;
  public navItemLog_CountryGroup_Excluded: number=2;
  //#endregion

  constructor(
    private alertsService              : AlertsService,
    private authenticationService      : AuthenticationService,
    private changeDetectorRef          : ChangeDetectorRef,
    private commConfigsService         : CommConfigService,
    private companiesService           : CompaniesService,
    private componentAccessUserService : ComponentAccessUserService,
    private configSystemService        : ConfigSystemService,
    private devicesService             : DevicesService,
    private encryptionService          : EncryptionService,
    private exceptionsService          : ExceptionsService,
    private formBuilder                : UntypedFormBuilder,
    private gridViewService            : GridViewService,
    private gridViewServiceCountries   : GridViewService,
    private gridViewServiceCountryGroup: GridViewService,
    private gridViewServiceUserGroup   : GridViewService,
    private lastPassKillerService      : LastPassKillerService,
    private modalForceCloseService     : ModalForceCloseService,
    private modalService               : NgbModal,
    private productsService            : ProductsService,
    private userGroupService           : UserGroupService
  ) {
    this.curUser         =this.authenticationService.currentUserObject();
    this.gridViewDefaults=new GridViewDefaults(this.authenticationService, this.componentAccessUserService, this.configSystemService, this.exceptionsService);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const targetElement = event.target as HTMLElement;

    // Check if the click is inside the alert modal
    if (this.isModalOpen && targetElement.closest('#alertFormDetails') && !targetElement.closest('.btn.btn-success.dropdown-toggle') && !targetElement.closest('.dropdown-menu')) {
      this.closeOpenedDropDown();
    }
  }

  public async ngOnInit(): Promise<void> {
    try {
      await this.setUpDgApiPaths();
      this.setUpDgActionColumn();
      this.setUpDgColumns();
      this.setUpDgPopup();
      this.setUpDgProperties();
      this.setUpDgTabs();

      await this.setUpDgApiPathsCountries();
      this.setUpDgActionColumnCountries();
      this.setUpDgColumnsCountries();
      this.setUpDgPopupCountries();
      this.setUpDgPropertiesCountries();
      this.setUpDgTabsCountries();

      await this.setUpDgApiPathsGroups();
      this.setUpDgActionColumnGroups();
      this.setUpDgColumnsGroups();
      this.setUpDgPopupGroups();
      this.setUpDgPropertiesGroups();
      this.setUpDgTabsGroups();

      await this.setUpDgApiPathsCountryGroups();
      this.setUpDgActionColumnCountryGroups();
      this.setUpDgColumnsCountryGroups();
      this.setUpDgPopupCountryGroups();
      this.setUpDgPropertiesCountryGroups();
      this.setUpDgTabsCountryGroups();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy() {
    try {
      this.lastPassKillerService.stop();
      //this.simProvisionBulkEmbeddedComponent.closeForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetMainVariables(): void {
    try {
      // this.addCompanyButtonEnabled  =true;
      // this.addUserButtonEnabled     =false;
      this.alertColourProgress           =AlertClassColour.Grey;
      this.alertFilterApplied            =false;
      this.alertCountryFilterApplied     =false;
      this.alertCountryGroupFilterApplied=false;
      this.alertGroupFilterApplied       =false;
      this.formSubmitted                 =false;
      this.activeId                      =1;
      this.activeIdCountry               =1;
      this.activeIdCountryGroup          =1;
      this.activeIdUserGroup             =1;
      this.addOnCompanyCreation          =false;
      this.defaultTemplate               =false;
      this.disableAddOnCompanyCreation   =false;
      this.disableTemplate               =false;
      this.planId                        =1;
      this.selectedAlertTypeId           =undefined;
      this.selectedEmailTemplateId       =undefined;
      this.selectedNotificationTemplateId=undefined;
      this.selectedSMSTemplateId         =undefined;
      this.setUpDgActionColumnCountries();
      this.setUpDgPropertiesCountries();

      if (this.gridView != undefined) {
        this.reapplyFilter();
      }

      if (this.gridViewCountries != undefined) {
        this.reapplyFilterCountry();
      }

      if (this.gridViewGroups != undefined) {
        this.reapplyFilterGroups();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public closeForm(): void {
    try {
      //this.simProvisionBulkEmbeddedComponent.closeForm()
      this.alertModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

public async openForm(alertId: number, companyId: number, templateId: number, alertGroupId: number): Promise<void> {
  try {
    this.isModalOpen         = true;
    this.sureSimCompanyId    = companyId;
    this.filterCompanyID     = companyId;
    this.getCompanyForCurrency(companyId);
    this.alertId             = alertId;
    this.alertGroupId        = alertGroupId;
    this.alertDevices        = [];
    this.alertTemplateId     = templateId;
    this.userGroups          = [];
    this.userGroupAllocations= [];

    this.resetMainVariables();
    this.startProcess(templateId > 0);
    this.getUsersSims();

    await this.getalertAndOpenModal(alertId);
  }
  catch(e) {
    this.exceptionsService.handleException(<Error>e);
  }
}

  private getCompanyForCurrency(companyId: number): void {
    try {
      this.company=undefined;

      if (companyId==undefined || companyId<=0)
        return;

      this.companiesService.getById(companyId).subscribe({
        next : data => {
          this.company=data;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private async getalertAndOpenModal(alertId: number): Promise<void> {
    try {
      if (alertId > 0) {
        const data=await firstValueFrom(this.alertsService.getById(alertId)
                                        .pipe(
                                          catchError(error => {
                                            throw new Error(this.exceptionsService.formatHttpError(error));
                                          })
                                        ));
  
        this.alert=data;
        if (this.alert.defaultTemplate) {
          this.planId = 2;
          this.disableAddOnCompanyCreation = true;
        }
  
        if (this.alert.addOnCompanyCreation) {
          this.planId = 3;
          this.disableTemplate = true;
        }

        if (this.alert.alertGroups == undefined) {
          this.alert.alertGroups = [];
        }

        if (this.alert.alertCountryGroups == undefined) {
          this.alert.alertCountryGroups = [];
        }

        this.alert.alertCountrySelections = [];
        this.alert.alertCountries         = [];

        if (this.alert.alertSims == undefined) {
          this.alert.alertSims = [];
        }
  
        if (this.alertForm != undefined && this.alert.alertTypeId != undefined) {
          this.selectedAlertTypeId = this.alert.alertTypeId;
        }
  
        if (this.alert.emailTemplateId > 0) {
          this.selectedEmailTemplateId = this.alert.emailTemplateId;
        }
  
        if (this.alert.notificationTemplateId > 0) {
          this.selectedNotificationTemplateId = this.alert.notificationTemplateId;
        }
  
        if (this.alert.smsTemplateId > 0) {
          this.selectedSMSTemplateId = this.alert.smsTemplateId;
        }
  
        this.populateFormFields();
        //this.validateProduct();
  
        await this.setDgApiPathGet(true);
        await this.setDgApiPathGetCountries(true);
        await this.setDgApiPathGetGroups(true);
        await this.setDgApiPathGetCountryGroups(true);
  
        this.getTemplateData();
        this.getUserGroups();
        this.getUserGroupAllocation();
  
        if (this.alertForm != undefined && !this.alert.emailEnabled) {
          this.alertForm.get('emailTemplateId')?.disable();
        }

        if (this.alertForm != undefined && !this.alert.notificationEnabled) {
          this.alertForm.get('notificationTemplateId')?.disable();
        }

        if (this.alertForm != undefined && !this.alert.smsEnabled) {
          this.alertForm.get('smsTemplateId')?.disable();
        }

        if (this.alertForm != undefined && !this.alert.throttleSpeedEnabled) {
          this.alertForm.get('throttleSpeedId')?.disable();
        }

        if (this.alertForm != undefined && !this.alert.changePlanEnabled) {
          this.alertForm.get('changePlanId')?.disable();
        }

        if (this.alertForm != undefined && !this.alert.increaseLimitEnabled) {
          this.alertForm.get('increaseLimitAmount')?.disable();
          this.alertForm.get('increaseLimitRepeatTimes')?.disable();
        }
  
        this.defaultTemplate      = this.alert.defaultTemplate;
        this.addOnCompanyCreation = this.alert.addOnCompanyCreation;
  
        this.openModal();
  
        return;
      }
      
      if (this.alertTemplateId > 0) {
        const data=await firstValueFrom(this.alertsService.createNewAlertByTemplateId(this.alertTemplateId, this.sureSimCompanyId ?? -1)
                                        .pipe(
                                          catchError(error => {
                                            throw new Error(this.exceptionsService.formatHttpError(error));
                                          })
                                        )
                                      );
  
        this.alert=data;
        this.alertId = this.alert.id;
  
        if (this.alertForm != undefined && this.alert.alertTypeId != undefined) {
          this.selectedAlertTypeId = this.alert.alertTypeId;
        }
  
        this.getTemplateData();
        this.getUserGroups();
        this.getUserGroupAllocation();
  
        if (this.alert.alertSims == undefined) {
          this.alert.alertSims = [];
        }
  
        if (this.alert.emailTemplateId > 0) {
          this.selectedEmailTemplateId = this.alert.emailTemplateId;
        }

        if (this.alert.notificationTemplateId > 0) {
          this.selectedNotificationTemplateId = this.alert.notificationTemplateId;
        }

        if (this.alert.smsTemplateId > 0) {
          this.selectedSMSTemplateId = this.alert.smsTemplateId;
        }
  
        this.populateFormFields();
        //this.validateProduct();
  
        await this.setDgApiPathGet(true);
        await this.setDgApiPathGetCountries(true);
        await this.setDgApiPathGetGroups(true);
        await this.setDgApiPathGetCountryGroups(true);
  
        if (this.alertForm != undefined && !this.alert.emailEnabled) {
          this.alertForm.get('emailTemplateId')?.disable();
        }

        if (this.alertForm != undefined && !this.alert.notificationEnabled) {
          this.alertForm.get('notificationTemplateId')?.disable();
        }

        if (this.alertForm != undefined && !this.alert.smsEnabled) {
          this.alertForm.get('smsTemplateId')?.disable();
        }

        if (this.alertForm != undefined && !this.alert.throttleSpeedEnabled) {
          this.alertForm.get('throttleSpeedId')?.disable();
        }

        if (this.alertForm != undefined && !this.alert.changePlanEnabled) {
          this.alertForm.get('changePlanId')?.disable();
        }

        if (this.alertForm != undefined && !this.alert.increaseLimitEnabled) {
          this.alertForm.get('increaseLimitAmount')?.disable();
          this.alertForm.get('increaseLimitRepeatTimes')?.disable();
        }
  
        this.defaultTemplate      = this.alert.defaultTemplate;
        this.addOnCompanyCreation = this.alert.addOnCompanyCreation;
  
        this.openModal();
  
        return;
      }
  
  
      this.alert = {
        active                  : true,
        addOnCompanyCreation    : false,
        alertTypeId             : -1,
        allCountries            : true,
        allGroups               : true,
        allSims                 : true,
        barService              : false,
        beingCreatedFromTemplate: false,
        changePlanEnabled       : false,
        changePlanId            : -1,
        companyID               : -1,
        defaultTemplate         : false,
        emailEnabled            : false,
        emailTemplateId         : -1,
        enteredBy               : -1,
        fullname                : '',
        id                      : -1,
        imeiIccid               : '',
        increaseLimitAmount     : 0,
        increaseLimitEnabled    : false,
        increaseLimitRepeatTimes:0,
        name                    : '',
        notificationEnabled     : false,
        notificationTemplateId  : -1,
        planId                  : 1,
        product                 : '',
        threshold               : 0,
        alertSims               : [],
        alertCountries          : [],
        alertCountrySelections  : [],
        alertCountryGroups      : [],
        alertGroups             : [],
        smsEnabled              : false,
        smsTemplateId           : -1,
        systemOwned             : false,
        throttleSpeedEnabled    : false,
        throttleSpeedId         : -1,
        username                : '',
      };
  
      this.populateFormFields();
  
      await this.setDgApiPathGet(true);
      await this.setDgApiPathGetCountries(true);
      await this.setDgApiPathGetGroups(true);
      await this.setDgApiPathGetCountryGroups(true);

      this.getTemplateData();
      this.getUserGroups();
      this.getUserGroupAllocation();
  
      if (this.alertForm != undefined && !this.alert.emailEnabled) {
        this.alertForm.get('emailTemplateId')?.disable();
      }
      if (this.alertForm != undefined && !this.alert.notificationEnabled) {
        this.alertForm.get('notificationTemplateId')?.disable();
      }
      if (this.alertForm != undefined && !this.alert.smsEnabled) {
        this.alertForm.get('smsTemplateId')?.disable();
      }
      if (this.alertForm != undefined && !this.alert.throttleSpeedEnabled) {
        this.alertForm.get('throttleSpeedId')?.disable();
      }
      if (this.alertForm != undefined && !this.alert.changePlanEnabled) {
        this.alertForm.get('changePlanId')?.disable();
      }
      if (this.alertForm != undefined && !this.alert.increaseLimitEnabled) {
        this.alertForm.get('increaseLimitAmount')?.disable();
        this.alertForm.get('increaseLimitRepeatTimes')?.disable();
      }
  
      this.openModal();
  
    }
    catch (e) {
      this.alertFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onAlertTypeIdChange(event : Event) : void {
    this.selectedAlertTypeId = this.alertForm.controls["alertTypeId"].value;

    this.getTemplateData()
  }

  private openModal(): void {
    try {
        this.alertModalFormRef = this.modalService.open(this.alertModalFormContent, { backdrop     : this.modalBackGround, 
                                                                                      centered     : true,
                                                                                      keyboard     : false,
                                                                                      size         : msSize.ExtraLarge, 
                                                                                      beforeDismiss: () => { return this.modalForceCloseService.isForcing(); },
                                                                                    }); 
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private populateFormFields() {
    try {
      if (this.alert != undefined) {
        this.alertForm.controls["active"].setValue(this.alert.active);
        this.alertForm.controls["alertTypeId"].setValue(this.alert.alertTypeId);
        this.alertForm.controls["allCountries"].setValue(this.alert.allCountries);
        this.alertForm.controls["allGroups"].setValue(this.alert.allGroups);
        this.alertForm.controls["allSims"].setValue(this.alert.allSims);
        this.alertForm.controls["barService"].setValue(this.alert.barService);
        this.alertForm.controls["changePlanEnabled"].setValue(this.alert.changePlanEnabled);
        this.alertForm.controls["changePlanId"].setValue(this.alert.changePlanId);
        this.alertForm.controls["companyId"].setValue(this.alert.companyID);
        this.alertForm.controls["emailEnabled"].setValue(this.alert.emailEnabled);
        this.alertForm.controls["emailTemplateId"].setValue(this.alert.emailTemplateId);
        this.alertForm.controls["id"].setValue(this.alert.id);
        this.alertForm.controls["increaseLimitEnabled"].setValue(this.alert.increaseLimitEnabled);
        this.alertForm.controls["increaseLimitAmount"].setValue(this.alert.increaseLimitAmount);
        this.alertForm.controls["increaseLimitRepeatTimes"].setValue(this.alert.increaseLimitRepeatTimes);
        this.alertForm.controls["name"].setValue(this.alert.name);
        this.alertForm.controls["notificationEnabled"].setValue(this.alert.notificationEnabled);
        this.alertForm.controls["notificationTemplateId"].setValue(this.alert.notificationTemplateId);
        this.alertForm.controls["threshold"].setValue(this.alert.threshold);
        this.alertForm.controls["smsEnabled"].setValue(this.alert.smsEnabled);
        this.alertForm.controls["smsTemplateId"].setValue(this.alert.smsTemplateId);
        this.alertForm.controls["systemOwned"].setValue(this.alert.systemOwned);
        this.alertForm.controls["throttleSpeedEnabled"].setValue(this.alert.throttleSpeedEnabled);
        this.alertForm.controls["throttleSpeedId"].setValue(this.alert.throttleSpeedId);
      }        
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private startProcess(beingCreatedFromTemplate : boolean): void {
    try {
      this.resetMainVariables();
      this.closeOpenedDropDown();
      this.refreshData();
      this.getCommunicationTemplateDefaults();
      this.getCommunicationTemplateReplacements();
      this.setUpForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region alertForm

  get formData() {
    return this.alertForm.controls;
  }

  public getCommunicationTemplateDefaults() {
    try {
      this.commConfigsService.getCompanyCommunicationTemplatesDefaults(this.filterCompanyID as number).subscribe({ 
          next: data => {
            this.companyDefaults = JSON.parse(JSON.stringify(data ?? {}));
           },
          error: error => {
            if (error && error.includes("404")) {
              this.companyDefaults = {
                  bcc           : undefined,
                  cc            : undefined,
                  companyId     : this.sureSimCompanyId,
                  enteredBy     : this.sureSimUserId,
                  fromEmail     : undefined,
                  fromNumber    : undefined,
                  id            : undefined,
                  toEmail       : undefined,
                  toNumber      : undefined,
              };
            } else {
              this.exceptionsService.handleException(new Error(error));
            }
          }
        });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getCommunicationTemplateReplacements() {
    try {
      this.commConfigsService.getCommunicationTemplateReplacements(this.curUser.userId, this.messageTypeId).subscribe(x => this.templateReplacements = x);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpForm() {
    try {
      this.buildForm();
      this.enableUserFields(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.alertForm);
      this.alertForm=this.formBuilder.group({ });
      this.addFormFields(this.alertForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.alertForm) {
        this.addFormControl(formGroup, "active",                    "", []);
        this.addFormControl(formGroup, "alertTypeId",               "", [Validators.required, Validators.min(1)]);
        this.addFormControl(formGroup, "allCountries",              "", []);
        this.addFormControl(formGroup, "allGroups",                 "", []);
        this.addFormControl(formGroup, "allSims",                   "", []);
        this.addFormControl(formGroup, "barService",                "", []);
        this.addFormControl(formGroup, "changePlanEnabled",         "", []);
        this.addFormControl(formGroup, "changePlanId",              "", []);
        this.addFormControl(formGroup, "companyId",                 "", []);
        this.addFormControl(formGroup, "emailEnabled",              "", []);
        this.addFormControl(formGroup, "emailTemplateId",           "", []);
        this.addFormControl(formGroup, "id",                        "", []);
        this.addFormControl(formGroup, "increaseLimitAmount",       "", []);
        this.addFormControl(formGroup, "increaseLimitEnabled",      "", []);
        this.addFormControl(formGroup, "increaseLimitRepeatTimes",  "", []);
        this.addFormControl(formGroup, "name",                      "", [Validators.required, Validators.maxLength(this.nameMaxLength)]);
        this.addFormControl(formGroup, "notificationEnabled",       "", []);
        this.addFormControl(formGroup, "notificationTemplateId",    "", []);

        if (this.alertGroupId == 1) {
          this.addFormControl(formGroup, "threshold",               "", [Validators.required, Validators.min(1)]);
        } else {
          this.addFormControl(formGroup, "threshold",               "", []);
        }

        this.addFormControl(formGroup, "smsEnabled",                "", []);
        this.addFormControl(formGroup, "smsTemplateId",             "", []);
        this.addFormControl(formGroup, "systemOwned",               "", []);
        this.addFormControl(formGroup, "throttleSpeedEnabled",      "", []);
        this.addFormControl(formGroup, "throttleSpeedId",           "", []);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : string,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public showGrid() {
    let result = !(this.defaultTemplate || this.addOnCompanyCreation);
    return result;
  }
  
  public alertFormCancel() {
    try {
      this.isModalOpen = false;
      this.alertFormCancelled.emit();
      this.alertModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onActiveCheckboxChange() {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public alertCompletedModalHasBeenClosed() {
    try {
      if (!this.DoNotCloseFormOnCompleted) {
         this.alertModalFormRef.close();
      }
      this.DoNotCloseFormOnCompleted=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  get formOfalertAdd() {
    return this.alertForm.controls;
  }

  public isNumber(value: any): boolean {
    return !isNaN(Number(value)) && typeof value !== 'boolean';
  }

  public alertFormSubmitAttempt() {
    try {
      if (this.templateOpen == false)
      {
        this.formSubmitted=true; 
  
        //this.validateProduct();
        
        if (this.alertForm.valid && 
            ((this.alertForm.controls["smsEnabled"].value && this.alertForm.controls["smsTemplateId"].value > 0) || 
             (this.alertForm.controls["emailEnabled"].value && this.alertForm.controls["emailTemplateId"].value > 0) || 
             (this.alertForm.controls["notificationEnabled"].value && this.alertForm.controls["notificationTemplateId"].value > 0)) &&
            this.countryValidation() &&
            this.increaseValidation()) {
          this.alertFormSubmit();
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public countryValidation(): boolean {
    if (this.alertForm.controls["alertTypeId"].value && !(this.alertForm.controls["alertTypeId"].value == 4 || this.alertForm.controls["alertTypeId"].value == 5)) {
      return true;
    }

    return (this.countryCoverage?.effectiveCount ?? 0) > 0 || this.alert?.allCountries == true;
  }

  public increaseValidation(): boolean {
    try {
      let valid = true;

      if (this.alertForm.controls["increaseLimitEnabled"].value) {
        valid = !(this.alertForm.controls["increaseLimitAmount"].value == "" || 
                  this.alertForm.controls["increaseLimitRepeatTimes"].value == "" ||
                  Number(this.alertForm.controls["increaseLimitAmount"].value) <= 0 || 
                  Number(this.alertForm.controls["increaseLimitRepeatTimes"].value) <= 0);
                 
        if (valid) {
          valid = (this.isNumber(this.alertForm.controls["increaseLimitAmount"].value) && this.isNumber(this.alertForm.controls["increaseLimitRepeatTimes"].value));
        }    
      }

      return valid;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public async alertFormSubmit() {
    try {
      await this.setDgApiPathGet(false,true);
      await this.prepareToSavealert();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async addOnCompanyCreationChange(): Promise<void> {
    try {
      const isChecked          =(this.pageHeader.switch1Ref.nativeElement as HTMLInputElement).checked;
      this.addOnCompanyCreation=isChecked;

      if (isChecked) {
        this.planId = 3;
      } else {
        this.planId = 1;
      }
      this.disableTemplate = isChecked;
      await this.setDgApiPathGetCountries(true);
      
      if (this.alert != null) {
        this.alert!.alertCountries = [];
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async defaultTemplateChange(): Promise<void> {
    try {
      const isChecked     =(this.pageHeader.switch0Ref.nativeElement as HTMLInputElement).checked;
      this.defaultTemplate=isChecked;

      if (isChecked) {
        this.planId = 2;
      } else {
        this.planId = 1;
      }
      this.disableAddOnCompanyCreation = isChecked;
      await this.setDgApiPathGetCountries(true);
      
      if (this.alert != null) {
        this.alert!.alertCountries = [];
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private async prepareToSavealert() {
    try {
      if (this.alert != undefined)
      {
        this.alert.active                  = this.alertForm.controls["active"].value;
        this.alert.addOnCompanyCreation    = this.addOnCompanyCreation;
        this.alert.alertTypeId             = this.alertForm.controls["alertTypeId"].value;
        this.alert.allGroups               = this.alertForm.controls["allGroups"].value;
        this.alert.allSims                 = this.alertForm.controls["allSims"].value;
        this.alert.companyID               = this.sureSimCompanyId;
        this.alert.defaultTemplate         = this.defaultTemplate;
        this.alert.enteredBy               = this.curUser.userId;
        // this.alert.enteredDate            = this.alertForm.controls["enteredDate"].value;
        this.alert.id                      = this.alertForm.controls["id"].value;
        this.alert.increaseLimitAmount     = this.alertForm.controls["increaseLimitEnabled"].value == true ? this.alertForm.controls["increaseLimitAmount"].value : undefined;
        this.alert.increaseLimitRepeatTimes= this.alertForm.controls["increaseLimitEnabled"].value == true ? this.alertForm.controls["increaseLimitRepeatTimes"].value : undefined;
        this.alert.name                    = this.alertForm.controls["name"].value;
        this.alert.threshold               = this.alertForm.controls["threshold"].value;
        this.alert.systemOwned             = this.alertForm.controls["systemOwned"].value;
    
        this.alert.barService              = this.alertForm.controls["barService"].value;
        this.alert.changePlanId            = this.alertForm.controls["changePlanEnabled"].value == true ? this.alertForm.controls["changePlanId"].value : undefined;
        this.alert.throttleSpeedId         = this.alertForm.controls["throttleSpeedEnabled"].value == true ? this.alertForm.controls["throttleSpeedId"].value : undefined;
    
        this.alert.emailEnabled            = this.alertForm.controls["emailEnabled"].value;
        this.alert.emailTemplateId         = this.alertForm.controls["emailTemplateId"].value;
        this.alert.notificationEnabled     = this.alertForm.controls["notificationEnabled"].value;
        this.alert.notificationTemplateId  = this.alertForm.controls["notificationTemplateId"].value;
        this.alert.smsEnabled              = this.alertForm.controls["smsEnabled"].value;
        this.alert.smsTemplateId           = this.alertForm.controls["smsTemplateId"].value;
 
        this.alertDevices.forEach((item) => {
          var simIndex = this.alert?.alertSims.findIndex(x => x.deviceID == item.deviceID);
          if (simIndex != undefined && simIndex > -1 ) {
              this.alert!.alertSims[simIndex].optInOptOutReason = item.optInOptOutReason;
            }
        });

        this.savealert(this.alert)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.alertColourProgress=AlertClassColour.Green;
            this.alertDataHasBeenSaved.emit();
            this.saveOrderProcessComplete();
          },
          error: error => {
            this.alertColourProgress=AlertClassColour.Red;
            this.progressInformation=`Process cannot continue - ${error.message}`;
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private saveOrderProcessComplete() {
    try {
      this.completedModalForm.openForm(this.alertSavedMessage, "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private savealert(alert: AlertDTO): Observable<AlertDTO> {
    return this.alertsService.save(alert);
  }

  public OptInButtonClick(e: any) {
    try {
      let row = e.row.data;
      if (row != null)
      {
        row.optIn      = true;
        row.optOut     = false;
        row.changed    = true;
        row.overridden = 'Pending'

        let index = this.alert?.alertSims.findIndex(item => item.deviceID === row.deviceID);

        if (index == -1 || index == undefined) {
          const newItem = {
                            changed          : true,
                            optIn            : true,
                            optOut           : false,
                            active           : true,
                            deleted          : false,
                            systemOwned      : false,
                            enteredDate      : new Date(2025, 1, 1, 0, 0, 0, 0),
                            deviceID         : row.deviceID,
                            alertId          : row.alertId,
                            enteredBy        : this.curUser.userId,
                            iD               : row.id,
                            externalRef      : "",
                            internalRef      : "",
                            seviceType       : "",
                            fullname         : "",
                            imeiIccid        : row.imeiIccid,
                            optInOptOutReason: "",
                            product          : "",
                            supplierName     : "",
                            userId           : row.userId,
                            username         : "",
                          };

          this.alert?.alertSims.push(newItem);
        } else {
          this.alert!.alertSims[index].changed = true;
          this.alert!.alertSims[index].optIn   = true;
          this.alert!.alertSims[index].optOut  = false;
        }
      }

      this.reapplyFilter();
      this.gridView.dataGrid.instance.repaintRows;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    } 
  }

  public IncludeButtonClickCountries(e: any) {
    try {
      let row = e.row.data;
      if (row != null)
      {
        row.alertId    = this.alertId;
        row.changed    = true;
        //row.overridden = 'Pending'

        let index = this.alert?.alertCountries.findIndex(item => item.countryId === row.countryId);

        if (index == -1 || index == undefined) {
          const newItem = {
                            active          : true,
                            changed         : true,
                            deleted         : false,
                            systemOwned     : false,
                            enteredDate     : new Date(2025, 1, 1, 0, 0, 0, 0),
                            alertId         : this.alertId,
                            companyId       : row.companyId,
                            countryId       : row.countryId,
                            enteredBy       : this.curUser.userId,
                            id              : -1,
                            planId          : this.planId,
                            previousAlertId : -1,
                            alertName       : "",
                            alias           : "",
                            alpha2Code      : "",
                            alpha3Code      : "",
                            countryFlagIcon : "",
                            countryName     : "",
                            flagIcon        : "",
                            numericCode     : "",
                            zone            : "",
                            zoneAlias       : "",
                          };

          this.alert?.alertCountries.push(newItem);
        } else {
          this.alert!.alertCountries[index].alertId = this.alertId;
          this.alert!.alertCountries[index].changed = true;
          //this.alert?.alertCountries.map(item => Number(item.id) === Number(row.id) ? { ...item, alertId: this.alertId, changed: true} : item); //, overridden: 'Pending'
        }
      }

      this.repaintCountryGrid();
      this.gridViewCountries.dataGrid.instance.repaintRows;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    } 
  }

  public confirmReassign(e: any) {
    try {
      this.reassignCountryData = e; 
      this.reassignConfirmationModal.openForm("WARNING",
                                               `Are you sure you want to reallocate ${e.row.data.countryName} to this alert?`,
                                               undefined,
                                               OurColors.Red,
                                               OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public confirmReassignAll() {
    try {
      this.reassignCountryData = undefined;
      this.reassignConfirmationModal.openForm("WARNING",
                                               `Are you sure you want to reallocate all previously assigned countries to this alert?`,
                                               undefined,
                                               OurColors.Red,
                                               OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public yesReassign() {
    if (this.reassignCountryData == undefined) {
      this.yesReassignAllCountries();
    } else {
      this.yesReassignCountry();
    }
  }

  public yesReassignCountry() {
    try {
      let row = this.reassignCountryData.row.data;
      if (row != null)
      {
        row.alertId    = this.alertId;
        row.changed    = true;
        //row.overridden = 'Pending'

        let index = this.alert?.alertCountries.findIndex(item => item.countryId === row.countryId);

        if (index == -1 || index == undefined) {
          const newItem = {
                            active          : true,
                            changed         : true,
                            deleted         : false,
                            systemOwned     : false,
                            enteredDate     : new Date(2025, 1, 1, 0, 0, 0, 0),
                            alertId         : this.alertId,
                            companyId       : row.companyId,
                            countryId       : row.countryId,
                            enteredBy       : this.curUser.userId,
                            id              : -1,
                            planId          : this.planId,
                            previousAlertId : -1,
                            alertName       : "",
                            alias           : "",
                            alpha2Code      : "",
                            alpha3Code      : "",
                            countryFlagIcon : "",
                            countryName     : "",
                            flagIcon        : "",
                            numericCode     : "",
                            zone            : "",
                            zoneAlias       : "",
                          };

          this.alert?.alertCountries.push(newItem);
        } else {
          this.alert!.alertCountries[index].previousAlertId = this.alert!.alertCountries[index].alertId;
          this.alert!.alertCountries[index].alertId = this.alertId;
          this.alert!.alertCountries[index].changed = true;
          //this.alert?.alertCountries.map(item => Number(item.id) === Number(row.id) ? { ...item, alertId: this.alertId, changed: true} : item); //, overridden: 'Pending'
        }
      }

      this.repaintCountryGrid();
      this.gridViewCountries.dataGrid.instance.repaintRows;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public RemoveButtonClickCountries(e: any) {
    try {
      let row = e.row.data;
      if (row != null)
      {
        row.alertId    = 0;
        row.changed    = true;

        //row.overridden = 'Pending'

        let index = this.alert?.alertCountries.findIndex(item => item.countryId === row.countryId);

        if (index == -1 || index == undefined) {
          const newItem = {
                            changed         : true,
                            active          : true,
                            deleted         : false,
                            systemOwned     : false,
                            enteredDate     : new Date(2025, 1, 1, 0, 0, 0, 0),
                            alertId         : 0,
                            companyId       : row.companyId,
                            countryId       : row.countryId,
                            enteredBy       : this.curUser.userId,
                            id              : -1,
                            planId          : this.planId,
                            previousAlertId : -1,
                            alertName       : "",
                            alias           : "",
                            alpha2Code      : "",
                            alpha3Code      : "",
                            countryFlagIcon : "",
                            countryName     : "",
                            flagIcon        : "",
                            numericCode     : "",
                            zone            : "",
                            zoneAlias       : "",
                          };

          this.alert?.alertCountries.push(newItem);
        } else {
          if (this.alert!.alertCountries[index].previousAlertId > 0) {
            row.alertId = this.alert!.alertCountries[index].previousAlertId
            row.changed = false;
            this.alert!.alertCountries[index].alertId = this.alert!.alertCountries[index].previousAlertId;
            this.alert!.alertCountries[index].changed = false;
          } else {
            this.alert!.alertCountries[index].alertId = 0;
            this.alert!.alertCountries[index].changed = true;
          }
          //this.alert?.alertCountries.map(item => item.id === row.iD ? { ...item, alertId: 0, changed: true} : item); //, overridden: 'Pending'
        }
      }

      this.repaintCountryGrid();
      this.gridViewCountries.dataGrid.instance.repaintRows;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    } 
  }

  public OptOutButtonClick(e: any) {
    try {
      let row = e.row.data;
      if (row != null)
      {
        row.optIn      = false;
        row.optOut     = true;
        row.changed    = true;
        row.overridden = 'Pending'

        let index = this.alert?.alertSims.findIndex(item => item.deviceID === row.deviceID);

        if (index == -1 || index == undefined) {
          const newItem = {
                            changed          : true,
                            optIn            : false,
                            optOut           : true,
                            active           : true,
                            deleted          : false,
                            systemOwned      : false,
                            enteredDate      : new Date(2025, 1, 1, 0, 0, 0, 0),
                            deviceID         : row.deviceID,
                            alertId          : row.alertId,
                            enteredBy        : this.curUser.userId,
                            iD               : row.id,
                            externalRef      : "",
                            internalRef      : "",
                            seviceType       : "",
                            fullname         : "",
                            imeiIccid        : row.imeiIccid,
                            optInOptOutReason: "",
                            product          : "",
                            supplierName     : "",
                            userId           : row.userId,
                            username         : "",
                          };

          this.alert?.alertSims.push(newItem);
        } else {
          this.alert!.alertSims[index].changed = true;
          this.alert!.alertSims[index].optIn   = false;
          this.alert!.alertSims[index].optOut  = true;
        }
        //this.alert?.alertSims.map(item => item.iD === row.iD ? { ...item, optIn: false, optOut: true, changed: true, overridden: 'Pending'} : item);
      }

      this.reapplyFilter();
      this.gridView.dataGrid.instance.repaintRows;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public reapplyFilter() {
    let filterValue: any;
    if (this.activeId == this.navItemLog_OptedIn) {
      filterValue = ['optIn', '=', true];
    }
    else {
      filterValue = ['optOut', '=', true];
    }
    const gridInstance = this.gridView.dataGrid.instance;  
    gridInstance.clearFilter(); // Clear the existing filter
    gridInstance.filter(filterValue); // Reapply the filter
  }

  public repaintCountryGrid() {
    const gridInstance = this.gridViewCountries.dataGrid.instance; 
    gridInstance.refresh();
  }

  public reapplyFilterCountry() {
    const gridInstance = this.gridViewCountries.dataGrid.instance; 
    var combinedFilter = gridInstance.getCombinedFilter(true);
    var existingFilters : any[] = [];

    if (combinedFilter != undefined) {
      combinedFilter.forEach((filter: any) =>
      {
        if (filter?.columnIndex != undefined) {
          existingFilters.push(filter);
        }
      });
    }

    let filterValue: any;
    if (this.activeIdCountry == this.navItemLog_Included) {
      filterValue = ['alertId', '=', this.alertId];
    } else if (this.activeIdCountry == this.navItemLog_Available) {
      filterValue = ['alertId', '=', 0];
    } else {
      filterValue = [['alertId', '>', 0], "and", ["alertId", "<>", this.alertId]];
    }

    gridInstance.clearFilter();
    gridInstance.filter(filterValue);

    existingFilters.forEach((filter: any) =>
     {
       if (filter?.columnIndex != undefined) {
         this.dgColumnsCountries[Number(filter?.columnIndex)].filterValue = filter?.filterValue;
         this.dgColumnsCountries[Number(filter?.columnIndex)].selectedFilterOperation = filter?.selectedFilterOperation;
       } 
     });
  }

  public onContentReady(event: any) { 
    if (!this.alertFilterApplied)
    {
      this.alertFilterApplied = true;
      this.reapplyFilter();
    }
  }

  public onContentReadyCountries(event: any) { 
    if (!this.alertCountryFilterApplied)
    {
      this.alertCountryFilterApplied = true;
      this.reapplyFilterCountry();
    }
  }

  public onContentReadyGroups(event: any) { 
    if (!this.alertGroupFilterApplied)
    {
      this.alertGroupFilterApplied = true;
      this.reapplyFilterGroups();
    }
  }

  public onTabChange(event: any) {
    try {
      this.activeId = <number>event;
      this.reapplyFilter();
      this.setDgApiPathGet(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onTabChangeCountries(event: any) {
    try {
      this.activeIdCountry = <number>event;
      //this.dgActionColumnCountries!.allowMore=this.activeIdCountry == this.navItemLog_UsedElsewhere;

      if (this.activeIdCountry == this.navItemLog_Available) {
        this.dgPropertiesCountries!.button1Options   = {
          text : "Include All",
          elementAttr: { style: "background-color: #299CDB; color: white;" },
          width: 100,
          onClick: () => {
            this.includeAll();
          },
        };
      } else if (this.activeIdCountry == this.navItemLog_Included) {
        this.dgPropertiesCountries!.button1Options   = {
          text : "Remove All",
          elementAttr: { style: "background-color: #F06548; color: white;" },
          width: 100,
          onClick: () => {
            this.removeAll();
          },
        };
      } else if (this.activeIdCountry == this.navItemLog_UsedElsewhere) {
        this.dgPropertiesCountries!.button1Options   = {
          text : "Include All",
          elementAttr: { style: "background-color: #299CDB; color: white;" },
          width: 100,
          onClick: () => {
            this.confirmReassignAll();
          },
        };
      }

      this.gridViewCountries.repaintGrid();

      this.setUpDgColumnsCountries();
      this.reapplyFilterCountry();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

//  public setColumnVisibility(visibleColumns: string[]) {
//    this.dgColumns.forEach((column: DgColumn) =>
//      {
//        if (visibleColumns.indexOf(column.dataField) > -1) {
//          column.gridVisible = true;
//          column.allowSearch = true;
//        }  
//        else {
//          column.gridVisible = false;
//          column.allowSearch = false;
//      } 
//      });
//  }

  public async setDgApiPathGet(refreshdata:boolean, getDataOnly:boolean=false): Promise<void> {
    try {
      //RBW_20260723 - The sims grid now loads via dgProperties.apiMethodOverrideGet (a POST carrying the encrypted
      //allocations in the request body), so there is no query-string URL to build here - we just trigger a refresh.
      //getDataOnly still fetches the device list directly through the same POST-based service method.
      if (refreshdata == true && this.gridView != null) {
        this.gridView.refreshData();
      }

      if (getDataOnly) {
        this.alertDevices = await lastValueFrom(this.alertsService.getAlertDevices(this.alertId ?? -1, this.getAllSimsValue(), this.getAllGroupsValue(), this.sureSimCompanyId ?? -1, this.alert?.alertGroups ?? [], this.alert?.alertSims ?? [])
                                        .pipe(
                                          catchError(error => {
                                            throw new Error(this.exceptionsService.formatHttpError(error));
                                          })
                                        ));
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getAllSimsValue(): boolean {
    try {
      if (this.alertForm != null &&
          this.alertForm.controls["allSims"] != null &&
          typeof this.alertForm.controls["allSims"].value === 'boolean') {
        return this.alertForm.controls["allSims"].value;
      }
      return false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private getAllGroupsValue(): boolean {
    try {
      if (this.alertForm != null &&
          this.alertForm.controls["allGroups"] != null &&
          typeof this.alertForm.controls["allGroups"].value === 'boolean') {
        return this.alertForm.controls["allGroups"].value;
      }
      return false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public async setDgApiPathGetCountries(refreshdata:boolean): Promise<void> {
    try {
      const { planIdEncResult,
              alertIdEncResult,
              alertTypeIdEncResult,
              companyIdEncResult }=await firstValueFrom(
                forkJoin({
                  planIdEncResult     : this.encryptionService.encrypt_AesServerSideForWeb(this.planId.toString()),
                  alertIdEncResult    : this.encryptionService.encrypt_AesServerSideForWeb((this.alertId ?? 0).toString()),
                  alertTypeIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb((this.selectedAlertTypeId ?? -1).toString()),
                  companyIdEncResult  : this.encryptionService.encrypt_AesServerSideForWeb((this.sureSimCompanyId ?? -1).toString(), true)
                })
              );

      const planIdEnc     =planIdEncResult.result;
      const alertIdEnc    =alertIdEncResult.result;
      const alertTypeIdEnc=alertTypeIdEncResult.result;
      const companyIdEncSS=companyIdEncResult.result;

      var params ="?companyIdEncSS=" + companyIdEncSS +
                  "&planIdEnc="      + planIdEnc +
                  "&alertIdEnc="     + alertIdEnc +
                  "&alertTypeIdEnc=" + alertTypeIdEnc;

      this.dgApiPathCountries!.get            =environment.eSimApi+eSimApiPaths.Alerts+"/"+eSimApiPaths.AlertsGetCountries + params;
      this.gridViewServiceCountries.apiPathGet=this.dgApiPathCountries!.get;

      if (refreshdata == true && this.gridViewCountries != null) {
        this.gridViewCountries.refreshData();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  } 

  private getTemplateData(dropDownChanged:boolean=false) {
    try {
      if (this.filterCompanyID != undefined && this.filterCompanyID>0) { 
        forkJoin({
                commConfigs: this.commConfigsService.getForCompanyAlert(this.filterCompanyID as number, this.alertId),
                commTemplates: this.commConfigsService.getCommunicationAlertTemplates(this.filterCompanyID as number, this.alertId, this.selectedAlertTypeId ?? -1),
              })
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe(({ commConfigs, commTemplates }) => {
              this.commConfigs = JSON.parse(JSON.stringify(commConfigs));
              this.commTemplates=commTemplates;
              this.dropDownStatus = {}
              this.closeOpenedDropDown();
              this.smsTemplates = this.commTemplates?.filter(y => y.deliveryTypeId == DeliveryType.SMS),
              this.emailTemplates = this.commTemplates?.filter(y => y.deliveryTypeId == DeliveryType.Email),
              this.notificationTemplates = this.commTemplates?.filter(y => y.deliveryTypeId == DeliveryType.Notification)
              this.templateButtonsEnabled = true;

              if (dropDownChanged) {
                if (this.selectedEmailTemplateId ?? 0 > 0) {
                  this.alertForm.controls["emailTemplateId"].setValue(this.selectedEmailTemplateId);
                }
                if (this.selectedNotificationTemplateId ?? 0 > 0) {
                  this.alertForm.controls["notificationTemplateId"].setValue(this.selectedNotificationTemplateId);
                }
                if (this.selectedSMSTemplateId ?? 0 > 0) {
                  this.alertForm.controls["smsTemplateId"].setValue(this.selectedSMSTemplateId);
                }
              }
              this.changeDetectorRef.detectChanges();
             })
            }
      }
      catch(e) {
        this.exceptionsService.handleException(<Error>e);
         return (undefined);
      }
    }

  private getUserGroupAllocation() {
    try {
      this.userGroupAllocations = [];
      this.userGroupService.GetUserGroupAllocationForCompany(this.filterCompanyID as number).subscribe({ 
          next: data => {
            this.userGroupAllocations = JSON.parse(JSON.stringify(data ?? {}));
           },
          error: error => {
            if (error && error.includes("404")) {
              this.userGroupAllocations = [];
            } else {
              this.exceptionsService.handleException(new Error(error));
            }
          }
        });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getUserGroups() {
    try {
      this.userGroups = [];
      this.userGroupService.getUserGroupsForCompanyByCompanyId(this.filterCompanyID as number).subscribe({ 
          next: data => {
            this.userGroups = JSON.parse(JSON.stringify(data ?? {}));
           },
          error: error => {
            if (error && error.includes("404")) {
              this.userGroups = [];
            } else {
              this.exceptionsService.handleException(new Error(error));
            }
          }
        });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

private async setUpDgApiPaths(): Promise<void> {
    try {
      this.dgApiPath     =this.gridViewDefaults.setUpDgApiPaths(apiPath)
      this.dgApiPath!.get=environment.eSimApi+eSimApiPaths.Alerts+"/"+eSimApiPaths.AlertsGetDevices;
      await this.setDgApiPathGet(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumn() {
    try {
      this.dgActionColumn                          =this.gridViewDefaults.setUpDgActionColumn();
      this.dgActionColumn!.allowDeleting           =true;
      this.dgActionColumn!.allowMore               =false;
      this.dgActionColumn!.cellTemplate            ="DataDrivenButtons";
      this.dgActionColumn!.deleteIcon              ="assets/images/_suresim/Button Opt Out 55x23.png";
      this.dgActionColumn!.deleteRowButtonCondition=(data:any) => {  
        let result = data.optIn == true;
        return result; 
      };
      this.dgActionColumn!.overrideDelete          =true;
      this.dgActionColumn!.updateIcon              ="assets/images/_suresim/Button Opt In 55x23.png";
      this.dgActionColumn!.updateRowButtonCondition=(data:any) => {  
        let result = data.optOut == true;
        return result; 
      };
      this.dgActionColumn!.width=DgActionColumnWidth.oneButtonWithLeftRightPadding;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPopup() {
    try {
      this.dgPopup               =this.gridViewDefaults.setUpDgPopup(popUpTitle);
      this.dgPopup!.overridePopup=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgProperties() {
    try {
      this.dgProperties                   =this.gridViewDefaults.setUpDgProperties(mainTitle, exportFilenameSuffix);
      //RBW_20260723 - Load the sims grid via a POST (request body) rather than a query-string GET, so the encrypted
      //allocation payload can't blow past IIS URL limits when all sims are opted in/out. defer() re-reads the live
      //allSims/allGroups/allocation state on every grid refresh (the grid re-subscribes each time it loads).
      this.dgProperties!.apiMethodOverrideGet=defer(() => this.alertsService.getAlertDevices(this.alertId ?? -1,
                                                                                             this.getAllSimsValue(),
                                                                                             this.getAllGroupsValue(),
                                                                                             this.sureSimCompanyId ?? -1,
                                                                                             this.alert?.alertGroups ?? [],
                                                                                             this.alert?.alertSims ?? []));
      this.dgProperties!.encryptDeleteSS  =true;
      this.dgProperties!.encryptPost      =true;
      this.dgProperties!.encryptPut       =true;
      this.dgProperties!.gridKey          ="AlertModalEditForm";
      this.dgProperties!.initialTab       =this.navItemLog_OptedIn; 
      this.dgProperties!.pageSize         =5,
      this.dgProperties!.remoteOperations =false;
      //this.dgProperties!.cacheEnabled     =false;
      this.dgProperties!.showAddButton    =false;
      this.dgProperties!.showRefreshButton=true;
      this.dgProperties!.showTabs         =true;
      //RBW20260710 - Grid is inside a modal, so skip the viewport-fill height logic which otherwise sets a height relative to the browser window/footer and hides rows at some zoom levels
      this.dgProperties!.skipStickyLayout =true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgColumns() {
    try {
      let dgColumn: DgColumn | undefined;

      //ID
      dgColumn             =this.gridViewDefaults.setUpDgColumn("id", "ID", 0, DgColumnDataType.number);
      dgColumn!.formVisible=false;
      dgColumn!.gridVisible=false;//this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowId, false);
      dgColumn!.width      =DgColumnWidths.id;
      this.dgColumns       =[dgColumn!];

      //OptIn
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("optIn", "In", "", DgColumnDataType.string);
      dgColumn!.formVisible       =false;
      dgColumn!.gridVisible       =false;
      //dgColumn!.filterValue       =true; //only works if visible
      dgColumn!.width             =68;
      this.dgColumns.push(dgColumn!);

      //OptOut
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("optOut", "Out", "", DgColumnDataType.string);
      dgColumn!.formVisible       =false;
      dgColumn!.gridVisible       =false;
      //dgColumn!.filterValue       =false; //only works if visible
      dgColumn!.width             =68;
      this.dgColumns.push(dgColumn!);
      
      //ImeiIccid
      dgColumn            =this.gridViewDefaults.setUpDgColumn("imeiIccid", "ICCID", "", DgColumnDataType.string);
      dgColumn!.validators=[Validators.required, Validators.maxLength(25)];
      dgColumn!.width     =172;
      // dgColumn!.cellTemplate    ="ICCIDTemplate"; //RBW20250716 - This will cause a Circular Dependencies, resulting in a Maximum call stack size exceeded, if this and the html bits are enabled
      // dgColumn!.cellTemplateType="link"
      this.dgColumns.push(dgColumn!);

      //DeviceType
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("deviceType", "Type", "", DgColumnDataType.string);
      dgColumn!.width             =75;
      this.dgColumns.push(dgColumn!);

      //Fullname
      dgColumn             =this.gridViewDefaults.setUpDgColumn("fullname", "Username", "", DgColumnDataType.string);
      dgColumn!.gridVisible=this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridManageEsimShowFullname, true);
      // dgColumn!.cellTemplate    ="FullNameTemplate"; //RBW20250716 - This will cause a Circular Dependencies, resulting in a Maximum call stack size exceeded, if this and the html bits are enabled
      // dgColumn!.cellTemplateType="link"f
      this.dgColumns.push(dgColumn!);

      //UserName
      dgColumn             =this.gridViewDefaults.setUpDgColumn("username", "User", "", DgColumnDataType.string);
      dgColumn!.gridVisible=this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridManageEsimShowUsername, false);
      // dgColumn!.cellTemplate    ="UserNameTemplate"; //RBW20250716 - This will cause a Circular Dependencies, resulting in a Maximum call stack size exceeded, if this and the html bits are enabled
      // dgColumn!.cellTemplateType="link"
      this.dgColumns.push(dgColumn!);

      //Product
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("product", "Product", "", DgColumnDataType.string);
      this.dgColumns.push(dgColumn!);

      //OptInOptOutReason
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("optInOptOutReason", "State", "", DgColumnDataType.string);
      this.dgColumns.push(dgColumn!);

      //Supplier
      // dgColumn                    =this.gridViewDefaults.setUpDgColumn("supplierName", "Supplier", "", DgColumnDataType.string);
      // this.dgColumns.push(dgColumn!);

      //CurrentLimit
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("currentSpendLimit", "Limit", "", DgColumnDataType.string);
      dgColumn!.width             =75;
      this.dgColumns.push(dgColumn!);

      //Overridden/Default/User Preference --RBW202250717 - Maybe useful in the future if we add the ability for the user to opt, as it can only be done at alert editing level it's not useful at the moment
      // dgColumn                    =this.gridViewDefaults.setUpDgColumn("overridden", "Opted", "", DgColumnDataType.string);
      // dgColumn!.width             =105;
      // this.dgColumns.push(dgColumn!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgTabs() {
    try {
      let dgTab: DgTab | undefined;
      
      //Available
      dgTab             =this.gridViewDefaults.setUpDgTab(this.navItemLog_OptedIn, "Opted In");
      this.dgTabs       =[dgTab!];

      //Reserved
      dgTab             =this.gridViewDefaults.setUpDgTab(this.navItemLog_OptedOut, "Opted Out");
      this.dgTabs.push(dgTab!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

private async setUpDgApiPathsCountries(): Promise<void> {
    try {
      this.dgApiPathCountries     =this.gridViewDefaults.setUpDgApiPaths(apiPathCountry)
      this.dgApiPathCountries!.get=environment.eSimApi+eSimApiPaths.Alerts+"/"+eSimApiPaths.AlertsGetCountries;
      await this.setDgApiPathGetCountries(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumnCountries() {
    try {
      this.dgActionColumnCountries                          =this.gridViewDefaults.setUpDgActionColumn();
      this.dgActionColumnCountries!.allowDeleting           =true;
      this.dgActionColumnCountries!.allowMore               =true;
      this.dgActionColumnCountries!.cellTemplate            ="DataDrivenButtons";
      this.dgActionColumnCountries!.deleteIcon              ="assets/images/_suresim/Button Remove 55x23.png";
      this.dgActionColumnCountries!.deleteRowButtonCondition=(data:any) => {  
        let result = data.alertId == this.alertId.toString();
        return result; 
      };
      this.dgActionColumnCountries!.overrideDelete          =true;
      this.dgActionColumnCountries!.updateIcon              ="assets/images/_suresim/Button Include 55x23.png";
      this.dgActionColumnCountries!.updateRowButtonCondition=(data:any) => {  
        let result = data.alertId == 0;
        return result; 
      };
      this.dgActionColumnCountries!.moreIcon                ="assets/images/_suresim/Button Include 55x23.png";
      this.dgActionColumnCountries!.moreRowButtonCondition=(data:any) => {  
        let result = this.activeIdCountry == this.navItemLog_UsedElsewhere && data.alertId > 0;
        return result; 
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPopupCountries() {
    try {
      this.dgPopupCountries               =this.gridViewDefaults.setUpDgPopup(popUpTitle);
      this.dgPopupCountries!.overridePopup=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public includeAll() {
    const gridInstance = this.gridViewCountries.dataGrid.instance; 
    var combinedFilter = gridInstance.getCombinedFilter();
    var datasource = gridInstance.getDataSource();
    datasource.store().load({ filter: combinedFilter }).then((data) => {
      var rows = data as AlertCountryDTO[];
      rows.forEach((item) => {
        item.alertId = this.alertId;
        item.changed = true;
        let index = this.alert?.alertCountries.findIndex(itemb => itemb.countryId === item.countryId);

        if (index == -1 || index == undefined) {
          const newItem = {
                            active          : true,
                            changed         : true,
                            deleted         : false,
                            systemOwned     : false,
                            enteredDate     : new Date(2025, 1, 1, 0, 0, 0, 0),
                            alertId         : this.alertId,
                            companyId       : item.companyId,
                            countryId       : item.countryId,
                            enteredBy       : this.curUser.userId,
                            id              : -1,
                            planId          : this.planId,
                            previousAlertId : -1,
                            alertName       : "",
                            alias           : "",
                            alpha2Code      : "",
                            alpha3Code      : "",
                            countryFlagIcon : "",
                            countryName     : "",
                            flagIcon        : "",
                            numericCode     : "",
                            zone            : "",
                            zoneAlias       : "",
                          };

          this.alert?.alertCountries.push(newItem);
        } else {
          this.alert!.alertCountries[index].alertId = this.alertId;
          this.alert!.alertCountries[index].changed = true;
        }
      }
    )});

    //this.setUpDgColumnsCountries();
    this.repaintCountryGrid();
  }

  public removeAll() {
    const gridInstance = this.gridViewCountries.dataGrid.instance;  
    var combinedFilter = gridInstance.getCombinedFilter();
    var datasource = gridInstance.getDataSource();
    datasource.store().load({ filter: combinedFilter }).then((data) => {
      var rows = data as AlertCountryDTO[];
      rows.forEach((item) => {
        item.alertId = 0;
        item.changed = true;
        let index = this.alert?.alertCountries.findIndex(itemb => itemb.countryId === item.countryId);

        if (index == -1 || index == undefined) {
          const newItem = {
                            active          : true,
                            changed         : true,
                            deleted         : false,
                            systemOwned     : false,
                            enteredDate     : new Date(2025, 1, 1, 0, 0, 0, 0),
                            alertId         : 0,
                            companyId       : item.companyId,
                            countryId       : item.countryId,
                            enteredBy       : this.curUser.userId,
                            id              : -1,
                            planId          : this.planId,
                            previousAlertId : -1,
                            alertName       : "",
                            alias           : "",
                            alpha2Code      : "",
                            alpha3Code      : "",
                            countryFlagIcon : "",
                            countryName     : "",
                            flagIcon        : "",
                            numericCode     : "",
                            zone            : "",
                            zoneAlias       : "",
                          };

          this.alert?.alertCountries.push(newItem);
        } else {
          if (this.alert!.alertCountries[index].previousAlertId > 0) {
            item.alertId = this.alert!.alertCountries[index].previousAlertId
            item.changed = false;
            this.alert!.alertCountries[index].alertId = this.alert!.alertCountries[index].previousAlertId;
            this.alert!.alertCountries[index].changed = false;
          } else {
            this.alert!.alertCountries[index].alertId = 0;
            this.alert!.alertCountries[index].changed = true;
          }
        }
      }
    )});

    //this.setUpDgColumnsCountries();
    this.repaintCountryGrid();

  }

  public yesReassignAllCountries() {
    const gridInstance = this.gridViewCountries.dataGrid.instance;  
    var combinedFilter = gridInstance.getCombinedFilter();
    var datasource = gridInstance.getDataSource();
    datasource.store().load({ filter: combinedFilter }).then((data) => {
      var rows = data as AlertCountryDTO[];
      rows.forEach((item) => {
        item.alertId = this.alertId;
        item.changed = true;

        let index = this.alert?.alertCountries.findIndex(itemb => itemb.countryId === item.countryId);

        if (index == -1 || index == undefined) {
          const newItem = {
                            active          : true,
                            changed         : true,
                            deleted         : false,
                            systemOwned     : false,
                            enteredDate     : new Date(2025, 1, 1, 0, 0, 0, 0),
                            alertId         : this.alertId,
                            companyId       : item.companyId,
                            countryId       : item.countryId,
                            enteredBy       : this.curUser.userId,
                            id              : -1,
                            planId          : this.planId,
                            previousAlertId : -1,
                            alertName       : "",
                            alias           : "",
                            alpha2Code      : "",
                            alpha3Code      : "",
                            countryFlagIcon : "",
                            countryName     : "",
                            flagIcon        : "",
                            numericCode     : "",
                            zone            : "",
                            zoneAlias       : "",
                          };

          this.alert?.alertCountries.push(newItem);
        } else {
          this.alert!.alertCountries[index].previousAlertId = this.alert!.alertCountries[index].alertId;
          this.alert!.alertCountries[index].alertId = this.alertId;
          this.alert!.alertCountries[index].changed = true;
        }
      }
    )});

    //this.setUpDgColumnsCountries();
    this.repaintCountryGrid();

  }

  private setUpDgPropertiesCountries() {
    try {
      this.dgPropertiesCountries                   =this.gridViewDefaults.setUpDgProperties(mainTitle, exportFilenameSuffix);
      this.dgPropertiesCountries!.button1Options   = {
          text : "Remove All",
          elementAttr: { style: "background-color: #F06548; color: white;" },
          width: 100,
          onClick: () => {
            this.removeAll();
          },
        },
      this.dgPropertiesCountries!.encryptDeleteSS  =true;
      this.dgPropertiesCountries!.encryptPost      =true;
      this.dgPropertiesCountries!.encryptPut       =true;
      this.dgPropertiesCountries!.initialTab       =this.navItemLog_Included;
      this.dgPropertiesCountries!.pageSize         =5,
      this.dgPropertiesCountries!.remoteOperations =false;
      //this.dgPropertiCountrieses!.cacheEnabled     =false;
      this.dgPropertiesCountries!.showAddButton    =false;
      this.dgPropertiesCountries!.showRefreshButton=true;
      this.dgPropertiesCountries!.showTabs         =true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgColumnsCountries() {
    try {
      let dgColumnCountries: DgColumn | undefined;
      
      //ID
      dgColumnCountries             =this.gridViewDefaults.setUpDgColumn("id", "ID", 0, DgColumnDataType.number);
      dgColumnCountries!.formVisible=false;
      dgColumnCountries!.gridVisible=false;//this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowId, false);
      dgColumnCountries!.width      =DgColumnWidths.id;
      this.dgColumnsCountries       =[dgColumnCountries!];

      //country icon
      dgColumnCountries             =this.gridViewDefaults.setUpDgColumn("countryFlagIcon", "Flag", "", DgColumnDataType.string);
      dgColumnCountries!.gridVisible=false;
      //dgColumnCountries!.allowSearch=false;
      this.dgColumnsCountries.push(dgColumnCountries!);

      //countryName
      dgColumnCountries                  =this.gridViewDefaults.setUpDgColumn("alias", "Country", "", DgColumnDataType.string); //countryName
      // dgColumnCountries!.width           =152; //20251006 RBW - Setting the width on this column caused the tabs to disappear and all rows to disappear
      dgColumnCountries!.cellTemplate    ="CountryTemplate";
      dgColumnCountries!.cellTemplateType="imageAndValue";
      dgColumnCountries!.imageColumn     ="countryFlagIcon";
      dgColumnCountries!.formVisible     =false;
      dgColumnCountries!.gridVisible     =true;
      this.dgColumnsCountries.push(dgColumnCountries!);

      //zoneAlias
      dgColumnCountries                =this.gridViewDefaults.setUpDgColumn("zoneAlias", "Zone", "", DgColumnDataType.string);
      dgColumnCountries!.formVisible   =false;
      dgColumnCountries!.gridVisible   =true;
      this.dgColumnsCountries.push(dgColumnCountries!);

      //PlanId
      dgColumnCountries                  =this.gridViewDefaults.setUpDgColumn("planId", "PlanId", 0, DgColumnDataType.number);
      dgColumnCountries!.formVisible     =false;
      dgColumnCountries!.gridVisible     =false;
      this.dgColumnsCountries.push(dgColumnCountries!);

      if (this.activeIdCountry == this.navItemLog_UsedElsewhere) {
        //Alert Name
        dgColumnCountries                =this.gridViewDefaults.setUpDgColumn("alertName", "Assigned To", "", DgColumnDataType.string);
        dgColumnCountries!.formVisible   =false;
        dgColumnCountries!.gridVisible   =true;
        this.dgColumnsCountries.push(dgColumnCountries!);

        //Alert Active
        dgColumnCountries                =this.gridViewDefaults.setUpDgColumn("alertActive", "Assigned To State", "", DgColumnDataType.string);
        dgColumnCountries!.formVisible   =false;
        dgColumnCountries!.gridVisible   =true;
        this.dgColumnsCountries.push(dgColumnCountries!);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgTabsCountries() {
    try {
      let dgTabCountries: DgTab | undefined;
      
      //Included
      dgTabCountries             =this.gridViewDefaults.setUpDgTab(this.navItemLog_Included, "Included");
      this.dgTabsCountries       =[dgTabCountries!];

      //Available
      dgTabCountries             =this.gridViewDefaults.setUpDgTab(this.navItemLog_Available, "Available");
      this.dgTabsCountries.push(dgTabCountries!);

      //UsedElsewhere
      dgTabCountries             =this.gridViewDefaults.setUpDgTab(this.navItemLog_UsedElsewhere, "Used Elsewhere");
      this.dgTabsCountries.push(dgTabCountries!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

//#region User Groups

  public async setDgApiPathGetGroups(refreshdata:boolean): Promise<void> {
    try {
      const { alertIdEncResult,
              companyIdEncResult,
              modifiedAlertGroupsEncResult }=await firstValueFrom(
                forkJoin({
                  alertIdEncResult            : this.encryptionService.encrypt_AesServerSideForWeb((this.alertId ?? 0).toString()),
                  companyIdEncResult          : this.encryptionService.encrypt_AesServerSideForWeb((this.sureSimCompanyId ?? -1).toString(), true),
                  modifiedAlertGroupsEncResult: this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(this.alert?.alertGroups ?? []))
                })
              );

      const alertIdEnc            =alertIdEncResult.result;
      const companyIdEncSS        =companyIdEncResult.result;
      const modifiedAlertGroupsEnc=modifiedAlertGroupsEncResult.result;
      
      var allGroups: boolean = false;
      if (this.alertForm != null &&
          this.alertForm.controls["allGroups"] != null &&
          typeof this.alertForm.controls["allGroups"].value === 'boolean') {
        allGroups=this.alertForm.controls["allGroups"].value;
      }

      this.dgApiPathGroups!.get=environment.eSimApi +
                                eSimApiPaths.UserGroups + '/' +
                                eSimApiPaths.UserGroupsGetAllGroupsForAlertId +
                                "?alertIdEnc=" + alertIdEnc +
                                "&companyIdEncSS=" + companyIdEncSS +
                                "&allGroups="+ allGroups +
                                "&modifiedAlertGroupAllocations=" + modifiedAlertGroupsEnc;

      this.gridViewServiceUserGroup.apiPathGet=this.dgApiPathGroups!.get;

      if (refreshdata == true && this.gridViewGroups != null) {
        this.gridViewGroups.refreshData();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  } 

  private async setUpDgApiPathsGroups(): Promise<void> {
    try {
      this.dgApiPathGroups     =this.gridViewDefaults.setUpDgApiPaths(apiPathGroup)
      this.dgApiPathGroups!.get=environment.eSimApi+eSimApiPaths.UserGroups+"/"+eSimApiPaths.UserGroupsGetAllGroupsForAlertId;
      await this.setDgApiPathGetGroups(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumnGroups() {
    try {
      this.dgActionColumnGroups                          =this.gridViewDefaults.setUpDgActionColumn();
      this.dgActionColumnGroups!.allowDeleting           =true;
      this.dgActionColumnGroups!.allowMore               =false;
      this.dgActionColumnGroups!.cellTemplate            ="DataDrivenButtons";
      this.dgActionColumnGroups!.deleteIcon              ="assets/images/_suresim/Button Remove 55x23.png";
      this.dgActionColumnGroups!.deleteRowButtonCondition=(data:any) => {  
        let result = data.included == true;
        return result; 
      };
      this.dgActionColumnGroups!.overrideDelete          =true;
      this.dgActionColumnGroups!.updateIcon              ="assets/images/_suresim/Button Include 55x23.png";
      this.dgActionColumnGroups!.updateRowButtonCondition=(data:any) => {  
        let result = data.excluded == true;
        return result; 
      };
      this.dgActionColumnGroups!.width=DgActionColumnWidth.oneButtonWithLeftRightPadding;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPopupGroups() {
    try {
      this.dgPopupGroups               =this.gridViewDefaults.setUpDgPopup(popUpTitle);
      this.dgPopupGroups!.overridePopup=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPropertiesGroups() {
    try {
      this.dgPropertiesGroups                   =this.gridViewDefaults.setUpDgProperties(mainTitle, exportFilenameSuffix);
      // this.dgPropertiesGroups!.button1Options   = {
      //     text : "Remove All",
      //     elementAttr: { style: "background-color: #F06548; color: white;" },
      //     width: 100,
      //     onClick: () => {
      //       this.removeAllGroups();
      //     },
      //   },
      this.dgPropertiesGroups!.encryptDeleteSS  =true;
      this.dgPropertiesGroups!.encryptPost      =true;
      this.dgPropertiesGroups!.encryptPut       =true;
      this.dgPropertiesGroups!.initialTab       =this.navItemLog_Group_Included;
      this.dgPropertiesGroups!.pageSize         =5,
      this.dgPropertiesGroups!.remoteOperations =false;
      //this.dgPropertiUserGroupes!.cacheEnabled     =false;
      this.dgPropertiesGroups!.showAddButton    =false;
      this.dgPropertiesGroups!.showRefreshButton=true;
      this.dgPropertiesGroups!.showTabs         =true;
      //RBW20260710 - Grid is inside a modal, so skip the viewport-fill height logic which otherwise sets a height relative to the browser window/footer and hides rows at some zoom levels
      this.dgPropertiesGroups!.skipStickyLayout =true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgColumnsGroups() {
    try {
      let dgColumnUserGroup: DgColumn | undefined;
      
      //ID
      dgColumnUserGroup             =this.gridViewDefaults.setUpDgColumn("id", "ID", 0, DgColumnDataType.number);
      dgColumnUserGroup!.formVisible=false;
      dgColumnUserGroup!.gridVisible=false;//this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowId, false);
      dgColumnUserGroup!.width      =DgColumnWidths.id;
      this.dgColumnsGroups       =[dgColumnUserGroup!];

      //userGroupName
      dgColumnUserGroup                  =this.gridViewDefaults.setUpDgColumn("groupName", "Group", "", DgColumnDataType.string); //userGroupName
      dgColumnUserGroup!.formVisible     =true;
      dgColumnUserGroup!.gridVisible     =true;
      this.dgColumnsGroups.push(dgColumnUserGroup!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgTabsGroups() {
    try {
      let dgTabUserGroup: DgTab | undefined;
      
      //Included
      dgTabUserGroup             =this.gridViewDefaults.setUpDgTab(this.navItemLog_Group_Included, "Included");
      this.dgTabsGroups       =[dgTabUserGroup!];

      //Excluded
      dgTabUserGroup             =this.gridViewDefaults.setUpDgTab(this.navItemLog_Group_Excluded, "Excluded");
      this.dgTabsGroups.push(dgTabUserGroup!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Country Groups grid

  public async setDgApiPathGetCountryGroups(refreshdata:boolean): Promise<void> {
    try {
      const { alertIdEncResult,
              companyIdEncResult,
              modifiedAlertCountryGroupsEncResult }=await firstValueFrom(
                forkJoin({
                  alertIdEncResult                   : this.encryptionService.encrypt_AesServerSideForWeb((this.alertId ?? 0).toString()),
                  companyIdEncResult                 : this.encryptionService.encrypt_AesServerSideForWeb((this.sureSimCompanyId ?? -1).toString(), true),
                  modifiedAlertCountryGroupsEncResult: this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(this.alert?.alertCountryGroups ?? []))
                })
              );

      const alertIdEnc                   =alertIdEncResult.result;
      const companyIdEncSS               =companyIdEncResult.result;
      const modifiedAlertCountryGroupsEnc=modifiedAlertCountryGroupsEncResult.result;

      var allCountries: boolean = false;
      if (this.alertForm != null &&
          this.alertForm.controls["allCountries"] != null &&
          typeof this.alertForm.controls["allCountries"].value === 'boolean') {
        allCountries=this.alertForm.controls["allCountries"].value;
      }

      this.dgApiPathCountryGroups!.get=environment.eSimApi +
                                eSimApiPaths.CountryGroups + '/' +
                                eSimApiPaths.CountryGroupsGetAllGroupsForAlert +
                                "?alertIdEnc=" + alertIdEnc +
                                "&companyIdEncSS=" + companyIdEncSS +
                                "&allCountries="+ allCountries +
                                "&modifiedAlertCountryGroupAllocations=" + modifiedAlertCountryGroupsEnc;

      this.gridViewServiceCountryGroup.apiPathGet=this.dgApiPathCountryGroups!.get;

      if (refreshdata == true && this.gridViewCountryGroups != null) {
        this.gridViewCountryGroups.refreshData();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private async setUpDgApiPathsCountryGroups(): Promise<void> {
    try {
      this.dgApiPathCountryGroups     =this.gridViewDefaults.setUpDgApiPaths(apiPathCountryGroup)
      this.dgApiPathCountryGroups!.get=environment.eSimApi+eSimApiPaths.CountryGroups+"/"+eSimApiPaths.CountryGroupsGetAllGroupsForAlert;
      await this.setDgApiPathGetCountryGroups(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumnCountryGroups() {
    try {
      this.dgActionColumnCountryGroups                          =this.gridViewDefaults.setUpDgActionColumn();
      this.dgActionColumnCountryGroups!.allowDeleting           =true;
      this.dgActionColumnCountryGroups!.allowMore               =false;
      this.dgActionColumnCountryGroups!.cellTemplate            ="DataDrivenButtons";
      this.dgActionColumnCountryGroups!.deleteIcon              ="assets/images/_suresim/Button Remove 55x23.png";
      this.dgActionColumnCountryGroups!.deleteRowButtonCondition=(data:any) => { return data.included == true; };
      this.dgActionColumnCountryGroups!.overrideDelete          =true;
      this.dgActionColumnCountryGroups!.updateIcon              ="assets/images/_suresim/Button Include 55x23.png";
      this.dgActionColumnCountryGroups!.updateRowButtonCondition=(data:any) => { return data.excluded == true; };
      this.dgActionColumnCountryGroups!.width                   =DgActionColumnWidth.oneButtonWithLeftRightPadding;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPopupCountryGroups() {
    try {
      this.dgPopupCountryGroups               =this.gridViewDefaults.setUpDgPopup(popUpTitle);
      this.dgPopupCountryGroups!.overridePopup=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPropertiesCountryGroups() {
    try {
      this.dgPropertiesCountryGroups                   =this.gridViewDefaults.setUpDgProperties(mainTitle, exportFilenameSuffix);
      this.dgPropertiesCountryGroups!.encryptDeleteSS  =true;
      this.dgPropertiesCountryGroups!.encryptPost      =true;
      this.dgPropertiesCountryGroups!.encryptPut       =true;
      this.dgPropertiesCountryGroups!.initialTab       =this.navItemLog_CountryGroup_Included;
      this.dgPropertiesCountryGroups!.pageSize         =5,
      this.dgPropertiesCountryGroups!.remoteOperations =false;
      this.dgPropertiesCountryGroups!.showAddButton    =false;
      this.dgPropertiesCountryGroups!.showRefreshButton=true;
      this.dgPropertiesCountryGroups!.showTabs         =true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgColumnsCountryGroups() {
    try {
      let dgColumn: DgColumn | undefined;

      //ID
      dgColumn             =this.gridViewDefaults.setUpDgColumn("id", "ID", 0, DgColumnDataType.number);
      dgColumn!.formVisible=false;
      dgColumn!.gridVisible=false;
      dgColumn!.width      =DgColumnWidths.id;
      this.dgColumnsCountryGroups=[dgColumn!];

      //GroupName
      dgColumn             =this.gridViewDefaults.setUpDgColumn("groupName", "Country Group", "", DgColumnDataType.string);
      dgColumn!.formVisible=true;
      dgColumn!.gridVisible=true;
      this.dgColumnsCountryGroups.push(dgColumn!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgTabsCountryGroups() {
    try {
      let dgTab: DgTab | undefined;

      dgTab                     =this.gridViewDefaults.setUpDgTab(this.navItemLog_CountryGroup_Included, "Included");
      this.dgTabsCountryGroups  =[dgTab!];

      dgTab                     =this.gridViewDefaults.setUpDgTab(this.navItemLog_CountryGroup_Excluded, "Excluded");
      this.dgTabsCountryGroups.push(dgTab!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public countryGroupsOnContentReady(event: any) {
    if (!this.alertCountryGroupFilterApplied)
    {
      this.alertCountryGroupFilterApplied = true;
      this.reapplyFilterCountryGroups();
    }
  }

  public countryGroupsOnTabChange(event: any) {
    try {
      this.activeIdCountryGroup = <number>event;
      this.gridViewCountryGroups.repaintGrid();
      this.reapplyFilterCountryGroups();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public reapplyFilterCountryGroups() {
    const gridInstance = this.gridViewCountryGroups.dataGrid.instance;
    let filterValue: any;
    if (this.activeIdCountryGroup == this.navItemLog_CountryGroup_Included) {
      filterValue = ['included', '=', true];
    }
    else {
      filterValue = ['excluded', '=', true];
    }
    gridInstance.clearFilter();
    gridInstance.filter(filterValue);
  }

  public repaintCountryGroupGrid() {
    const gridInstance = this.gridViewCountryGroups.dataGrid.instance;
    gridInstance.refresh();
  }

  private upsertAlertCountryGroup(row: any, included: boolean) {
    let index = this.alert?.alertCountryGroups.findIndex(item => item.groupId === row.groupId);

    if (index == -1 || index == undefined) {
      const newItem: AlertCountryGroupDTO = {
        active      : true,
        alertId     : this.alertId,
        changed     : true,
        deleted     : false,
        enteredBy   : this.curUser.userId,
        enteredDate : new Date(2025, 1, 1, 0, 0, 0, 0),
        excluded    : !included,
        iD          : row.id,
        included    : included,
        systemOwned : false,
        groupId     : row.groupId,
        externalRef : "",
        internalRef : "",
        groupName   : "",
      };
      this.alert?.alertCountryGroups.push(newItem);
    } else {
      this.alert!.alertCountryGroups[index].changed  = true;
      this.alert!.alertCountryGroups[index].excluded = !included;
      this.alert!.alertCountryGroups[index].included = included;
    }
  }

  public countryGroupsIncludeButtonClick(e: any) {
    try {
      let row = e.row.data;
      if (row != null)
      {
        row.included = true;
        row.excluded = false;
        row.changed  = true;
        this.upsertAlertCountryGroup(row, true);
      }
      this.repaintCountryGroupGrid();
      this.gridViewCountryGroups.dataGrid.instance.repaintRows;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public countryGroupsRemoveButtonClick(e: any) {
    try {
      let row = e.row.data;
      if (row != null)
      {
        row.included = false;
        row.excluded = true;
        row.changed  = true;
        this.upsertAlertCountryGroup(row, false);
      }
      this.reapplyFilterCountryGroups();
      this.gridViewCountryGroups.dataGrid.instance.repaintRows;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async onAllCountriesCheckboxChange(event: Event): Promise<void> {
    const isChecked = (event.target as HTMLInputElement).checked;

    const gridInstance = this.gridViewCountryGroups.dataGrid.instance;
    var datasource     = gridInstance.getDataSource();
    datasource.store().load({}).then((data) => {
      var rows = data as AlertCountryGroupDTO[];
      rows.forEach((item) => {
        this.upsertAlertCountryGroup(item, isChecked);
      });
    });

    await this.setDgApiPathGetCountryGroups(true);
  }

  //#endregion

  public groupsOnTabChange(event: any) {
    try {
      this.activeIdUserGroup = <number>event;

      // if (this.activeIdUserGroup == this.navItemLog_Group_Excluded) {
      //   this.dgPropertiesGroups!.button1Options   = {
      //     text : "Include All",
      //     elementAttr: { style: "background-color: #299CDB; color: white;" },
      //     width: 100,
      //     onClick: () => {
      //       this.includeAllGroups();
      //     },
      //   };
      // } else if (this.activeIdUserGroup == this.navItemLog_Group_Included) {
      //   this.dgPropertiesGroups!.button1Options   = {
      //     text : "Remove All",
      //     elementAttr: { style: "background-color: #F06548; color: white;" },
      //     width: 100,
      //     onClick: () => {
      //       this.removeAllGroups();
      //     },
      //   };
      // }

      this.gridViewGroups.repaintGrid();

      // this.setUpDgColumnsGroups();
      this.reapplyFilterGroups();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public reapplyFilterGroups() {
    const gridInstance = this.gridViewGroups.dataGrid.instance; 
    var combinedFilter = gridInstance.getCombinedFilter(true);
    var existingFilters : any[] = [];

    if (combinedFilter != undefined) {
      combinedFilter.forEach((filter: any) =>
      {
        if (filter?.columnIndex != undefined) {
          existingFilters.push(filter);
        }
      });
    }

    let filterValue: any;
    if (this.activeIdUserGroup == this.navItemLog_Group_Included) {
      filterValue = ['included', '=', true];
    }
    else {
      filterValue = ['excluded', '=', true];
    }
    gridInstance.clearFilter(); // Clear the existing filter
    gridInstance.filter(filterValue); // Reapply the filter

    existingFilters.forEach((filter: any) =>
     {
       if (filter?.columnIndex != undefined) {
         this.dgColumnsGroups[Number(filter?.columnIndex)].filterValue = filter?.filterValue;
         this.dgColumnsGroups[Number(filter?.columnIndex)].selectedFilterOperation = filter?.selectedFilterOperation;
       } 
     });
  }

  public repaintUserGroupGrid() {
    const gridInstance = this.gridViewGroups.dataGrid.instance; 
    gridInstance.refresh();
  }

  public groupsIncludeButtonClick(e: any) {
    try {
      let row = e.row.data;
      if (row != null)
      {
        row.included   = true;
        row.excluded   = false;
        row.changed    = true;

        let index = this.alert?.alertGroups.findIndex(item => item.groupId === row.groupId);

        if (index == -1 || index == undefined) {
          const newItem = {
                            active       : true,
                            alertId      : this.alertId,
                            changed      : true,
                            companyID    : row.companyID,
                            deleted      : false,
                            enteredBy    : this.curUser.userId,
                            enteredDate  : new Date(2025, 1, 1, 0, 0, 0, 0),
                            excluded     : false,
                            iD           : row.id,
                            included     : true,
                            systemOwned  : false,
                            groupId      : row.groupId,
                            userId       : row.userId,
                            externalRef  : "",
                            fullname     : "",
                            // imeiIccid    : "",
                            internalRef  : "",
                            groupName    : "",
                            // product      : "",
                            // serviceType  : "",
                            // supplierName : "",
                            username     : "",
                          };

          this.alert?.alertGroups.push(newItem);
        } else {
          this.alert!.alertGroups[index].changed  = true;
          this.alert!.alertGroups[index].excluded = false;
          this.alert!.alertGroups[index].included = true;
        }
      }

      if (this.alert?.alertSims != null) {
        this.alert?.alertSims.forEach((alertSim: any) =>
        {
          var allocationIndex = this.userGroupAllocations.findIndex(x => x.userId == alertSim.userId && x.groupId == row.groupId);
          if (allocationIndex != undefined && allocationIndex > -1) {
            var index = this.alert?.alertSims.findIndex(x => x.userId == alertSim.userId);
            if (index != undefined && index > -1) {
              this.alert!.alertSims[index].changed= true;
              this.alert!.alertSims[index].optIn  = true;
              this.alert!.alertSims[index].optOut = false;
            }
            else {
              alertSim.changed = true;
              alertSim.optIn   = true;
              alertSim.optOut  = false;
              this.alert?.alertSims.push(alertSim);
            }
          }
        });

        this.reapplyFilter();
        this.gridView.dataGrid.instance.repaintRows;
      }

      this.repaintUserGroupGrid();
      this.gridViewGroups.dataGrid.instance.repaintRows;
      this.setDgApiPathGet(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    } 
  }

  public groupsRemoveButtonClick(e: any) {
    try {
      let row = e.row.data;
      if (row != null)
      {
        row.included   = false;
        row.excluded   = true;
        row.changed    = true;

        let index = this.alert?.alertGroups.findIndex(item => item.groupId === row.groupId);

        if (index == -1 || index == undefined) {
          const newItem = {
                            active       : true,
                            alertId      : this.alertId,
                            changed      : true,
                            companyID    : row.companyID,
                            deleted      : false,
                            enteredBy    : this.curUser.userId,
                            enteredDate  : new Date(2025, 1, 1, 0, 0, 0, 0),
                            excluded     : true,
                            iD           : row.id,
                            included     : false,
                            systemOwned  : false,
                            groupId      : row.groupId,
                            userId       : row.userId,
                            externalRef  : "",
                            fullname     : "",
                            // imeiIccid    : "",
                            internalRef  : "",
                            groupName    : "",
                            // product      : "",
                            // serviceType  : "",
                            // supplierName : "",
                            username     : "",
                          };

          this.alert!.alertGroups.push(newItem);
        } else {
          this.alert!.alertGroups[index].changed  = true;
          this.alert!.alertGroups[index].excluded = true;
          this.alert!.alertGroups[index].included = false;
        }
      }

      if (this.alert?.alertSims != null) {
        this.alert?.alertSims.forEach((alertSim: any) =>
        {
          var allocationIndex = this.userGroupAllocations.findIndex(x => x.userId == alertSim.userId && x.groupId == row.groupId);
          var otherAllocationIndex = this.userGroupAllocations.findIndex(x => x.userId == alertSim.userId && x.groupId != row.groupId && row.Included == true);
          if (otherAllocationIndex == undefined || otherAllocationIndex == -1) {
            if (allocationIndex != undefined && allocationIndex > -1) {
              var index = this.alert?.alertSims.findIndex(x => x.userId == alertSim.userId);
              if (index != undefined && index > -1) {
                this.alert!.alertSims[index].changed= true;
                this.alert!.alertSims[index].optIn  = false;
                this.alert!.alertSims[index].optOut = true;
              }
              else {
                alertSim.changed = true;
                alertSim.optIn   = false;
                alertSim.optOut  = true;
                this.alert?.alertSims.push(alertSim);
              }
            }
          }
        });

        this.reapplyFilter();
        this.gridView.dataGrid.instance.repaintRows;
      }

      //this.repaintUserGroupGrid();
      this.reapplyFilterGroups();
      this.gridViewGroups.dataGrid.instance.repaintRows;
      this.setDgApiPathGet(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    } 
  }

  public areThereUserGroupsToShow(): boolean {
    var userGroupCount = this.userGroups?.length;
    return userGroupCount > 0;
  }

  public userGroupValidation(): boolean {
    //RBW_20260203 - There is no validation when the form is used for group selection.
    // if (this.showGroupsGrid()) {
    //   return true;
    // }
    // var userGroups = this.userGroup?.allocations.filter(x => x.included == true);
    // if (userGroups == undefined) {
    //   return false;
    // }

    // var userGroupCount = userGroups?.length;
    // return userGroupCount > 0;
    return true;
  }
//#endregion

  public toggleDropdown(key: string) {
    let dropDownVal = this.dropDownStatus[MessageType.Alert][key];
    this.closeOpenedDropDown();
    this.dropDownStatus[MessageType.Alert][key] = !dropDownVal;
  }

  closeOpenedDropDown() {
    this.dropDownStatus[MessageType.Alert] = {
      smsOpen: false,
      emailOpen: false,
      notificationOpen: false,
    };
  }

  public enableUserFields(enabled:boolean) {
    try {
      // if (enabled) {
      //   this.alertForm.controls["increaseLimitAmount"].enable();
      //   this.alertForm.controls["increaseLimitRepeatTimes"].enable();
      // } else {
      //   this.alertForm.controls["increaseLimitAmount"].disable();
      //   this.alertForm.controls["increaseLimitRepeatTimes"].disable();
      // }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async onAllGroupsCheckboxChange(event: Event): Promise<void> {
    const isChecked = (event.target as HTMLInputElement).checked;

    const gridInstance = this.gridViewGroups.dataGrid.instance; 
    // var combinedFilter = gridInstance.getCombinedFilter();
    var datasource     = gridInstance.getDataSource();
    datasource.store().load({}).then((data) => {
      var rows = data as AlertGroupDTO[];
      rows.forEach((item) => {
        let index = this.alert?.alertGroups.findIndex(itemb => itemb.groupId === item.groupId);

        if (index == -1 || index == undefined) {
          const newItem = {
                            active       : true,
                            alertId      : this.alertId,
                            changed      : true,
                            companyID    : this.sureSimCompanyId,
                            deleted      : false,
                            enteredBy    : this.curUser.userId,
                            enteredDate  : new Date(2025, 1, 1, 0, 0, 0, 0),
                            excluded     : !isChecked,
                            iD           : item.iD,
                            included     : isChecked,
                            systemOwned  : false,
                            groupId      : item.groupId,
                            userId       : null,
                            externalRef  : "",
                            fullname     : "",
                            // imeiIccid    : "",
                            internalRef  : "",
                            groupName    : "",
                            // product      : "",
                            // serviceType  : "",
                            // supplierName : "",
                            username     : "",
                          };

          this.alert?.alertGroups.push(newItem);
        } else {
          this.alert!.alertGroups[index].changed  = true;
          this.alert!.alertGroups[index].excluded = !isChecked;
          this.alert!.alertGroups[index].included = isChecked;
        }
      }
    )});

    if (this.alert?.alertSims != null) {
      this.alert?.alertGroups.forEach((alertGroup: any) =>
      {
        this.alert?.alertSims.forEach((alertSim: any) =>
        {
          var allocationIndex = this.userGroupAllocations.findIndex(x => x.userId == alertSim.userId && x.groupId == alertGroup.groupId);
          if (isChecked) {
            if (allocationIndex != undefined && allocationIndex > -1) {
              var index = this.alert?.alertSims.findIndex(x => x.userId == alertSim.userId);
              if (index != undefined && index > -1) {
                this.alert!.alertSims[index].changed= true;
                this.alert!.alertSims[index].optIn  = true;
                this.alert!.alertSims[index].optOut = false;
              }
              else {
                alertSim.changed = true;
                alertSim.optIn   = true;
                alertSim.optOut  = false;
                this.alert?.alertSims.push(alertSim);
              }
            }
          }
          else {
            var otherAllocationIndex = this.userGroupAllocations.findIndex(x => x.userId == alertSim.userId && x.groupId != alertGroup.groupId && alertGroup.Included == true);
            if (otherAllocationIndex == undefined || otherAllocationIndex == -1) {
              if (allocationIndex != undefined && allocationIndex > -1) {
                var index = this.alert?.alertSims.findIndex(x => x.userId == alertSim.userId);
                if (index != undefined && index > -1) {
                  this.alert!.alertSims[index].changed= true;
                  this.alert!.alertSims[index].optIn  = false;
                  this.alert!.alertSims[index].optOut = true;
                }
                else {
                  alertSim.changed = true;
                  alertSim.optIn   = false;
                  alertSim.optOut  = true;
                  this.alert?.alertSims.push(alertSim);
                }
              }
            }
          }
        });
      });

      this.reapplyFilter();
      this.gridView.dataGrid.instance.repaintRows;
    }

    await this.setDgApiPathGetGroups(true)
    await this.setDgApiPathGet(true);
  }

  public async onAllSimsCheckboxChange(event: Event): Promise<void> {
    const isChecked = (event.target as HTMLInputElement).checked;

    const gridInstance = this.gridView.dataGrid.instance; 
    // var combinedFilter = gridInstance.getCombinedFilter();
    var datasource     = gridInstance.getDataSource();
    datasource.store().load({}).then((data) => {
      var rows = data as AlertDeviceDTO[];
      rows.forEach((item) => {
        var userGroupIndex = this.userGroupAllocations.findIndex(x => x.userId == item.userId);
        if (userGroupIndex == -1 || userGroupIndex == undefined) {
          let index = this.alert?.alertSims.findIndex(itemb => itemb.deviceID === item.deviceID);
          if (index == -1 || index == undefined) {
            const newItem = {
                              changed          : true,
                              optIn            : isChecked,
                              optOut           : !isChecked,
                              active           : true,
                              deleted          : false,
                              systemOwned      : false,
                              enteredDate      : new Date(2025, 1, 1, 0, 0, 0, 0),
                              deviceID         : item.deviceID,
                              alertId          : item.alertId,
                              enteredBy        : this.curUser.userId,
                              iD               : item.iD,
                              externalRef      : "",
                              internalRef      : "",
                              seviceType       : "",
                              fullname         : "",
                              imeiIccid        : item.imeiIccid,
                              optInOptOutReason: "",
                              product          : "",
                              supplierName     : "",
                              userId           : item.userId,
                              username         : "",
                            };
  
            this.alert?.alertSims.push(newItem);
          } else {
            this.alert!.alertSims[index].changed = true;
            this.alert!.alertSims[index].optIn   = isChecked;
            this.alert!.alertSims[index].optOut  = !isChecked;
          }
        }
      }
    )});

    this.reapplyFilter();
    this.gridView.dataGrid.instance.repaintRows;

    await this.setDgApiPathGet(true);
  }

  public onBarCheckboxChange(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
        this.alertForm.controls["changePlanEnabled"].setValue(false);
        this.alertForm.controls["increaseLimitEnabled"].setValue(false);
        this.alertForm.controls["throttleSpeedEnabled"].setValue(false);
        this.alertForm.controls["increaseLimitAmount"].disable();
        this.alertForm.controls["increaseLimitRepeatTimes"].disable();
    }
  }

  public onProductCheckboxChange(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
        this.alertForm.controls["barService"].setValue(false);
        this.alertForm.controls["increaseLimitEnabled"].setValue(false);
        this.alertForm.controls["throttleSpeedEnabled"].setValue(false);
        this.alertForm.controls["increaseLimitAmount"].disable();
        this.alertForm.controls["increaseLimitRepeatTimes"].disable();
    }
  }

  public onThrottleSpeedCheckboxChange(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
        this.alertForm.controls["barService"].setValue(false);
        this.alertForm.controls["changePlanEnabled"].setValue(false);
        this.alertForm.controls["increaseLimitEnabled"].setValue(false);
        this.alertForm.controls["increaseLimitAmount"].disable();
        this.alertForm.controls["increaseLimitRepeatTimes"].disable();
    }
  }

  public onIncreaseCheckboxChange(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
        this.alertForm.controls["barService"].setValue(false);
        this.alertForm.controls["changePlanEnabled"].setValue(false);
        this.alertForm.controls["throttleSpeedEnabled"].setValue(false);
        this.alertForm.controls["increaseLimitAmount"].enable();
        this.alertForm.controls["increaseLimitRepeatTimes"].enable();
    } else {
        this.alertForm.controls["increaseLimitAmount"].disable();
        this.alertForm.controls["increaseLimitRepeatTimes"].disable();
    }
  }

  public alertTypeDropDownOnChange(event: number) {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public throttleSpeedTypeDropDownOnChange(event: number) {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  //#endregion

  //#region Process Complete

  public completedModalHasBeenClosed() {
    try {
      if (this.embeddedFormMode) {
        this.startProcess(false);
      } 
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Dropdown Arrays

  public getDropdownDataObjectArray(fieldName: string) {
    try {
      if (fieldName=="inviewCompanyId") {
        return this.inviewCompanyIdData;

      } else if (fieldName=="alertTypeId") {
        return this.alertTypeIdData;

      } else if (fieldName=="productId") {
        return this.productIdData;

      } else if (fieldName=="throttleSpeedId") {
        return this.throttleSpeedIdData;

      }

      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  public getDropdownDataObjectArray_InviewUser() {
    try {
      return this.inviewUserIdData;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="inviewCompanyId") {
              this.inviewCompanyIdData=(data as IdAndDescriptionDTO[]);

              if (!this.initialInviewCompanyIdSet && this.initialInviewCompanyId != undefined && this.initialInviewCompanyId>0) {
                this.alertForm.controls["inviewCompanyId"].setValue(this.initialInviewCompanyId);
                
                this.initialInviewCompanyIdSet=true;
              }

            } else if (fieldName=="alertTypeId") {
              this.alertTypeIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="productId") {
              this.productIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="throttleSpeedId") {
              this.throttleSpeedIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="inviewUserId") {
              this.inviewUserIdData=(data as InviewUserDTO[]);

            } 
           },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region SureSIM Data

  public refreshData() {
    try {
      this.getDropdownData(this.alertsService.getTypeAlertIdAndDescription(this.alertGroupId), "alertTypeId");
      this.getDropdownData(this.productsService.getAvailableIdAndDescription(), "productId");
      this.getDropdownData(this.alertsService.getTypeThrottleSpeedIdAndDescription(), "throttleSpeedId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region for Email Template

  public CanEditEmailTemplate() : boolean {
    let result = this.alertForm.controls["emailEnabled"].value && this.templateButtonsEnabled && ((this.selectedEmailTemplateId ?? 0) > 0);
    return result;
  }

  public emailTemplateModalFormClosed(event : {TemplateModalAction : TemplateModalAction,TemplateId : number}) {
    try{
      this.templateOpen           = false; 
      this.templateButtonsEnabled = false;
      if(event.TemplateModalAction == TemplateModalAction.Save || event.TemplateModalAction == TemplateModalAction.SaveAndEnable){
        this.alertForm.controls["emailEnabled"].setValue(true);
        this.selectedEmailTemplateId = event.TemplateId;
        this.getTemplateData(true);
      }else {
        this.templateButtonsEnabled = true;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  public onEmailChange(event : Event) : void {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedEmailTemplateId = Number(selectElement.value);
  }

  public openEmailTemplate(newTemplate:boolean) : void {
    try {
      this.templateOpen = true; 
      this.toggleDropdown('emailOpen');
      let template;
      if(!newTemplate && this.selectedEmailTemplateId != undefined){
        template = this.emailTemplates.find(y => y.id == this.selectedEmailTemplateId); 
      }
      else{
        template = {
          alertTypeId           : this.selectedAlertTypeId,
          id                    : 0,
          messageTypeId         : MessageType.Alert,
          name                  : null,
          subject               : null,
          body                  : null,
          bcc                   : null,
          cc                    : null,
          fromEmail             : null,
          fromNumber            : null,
          sendToUser            : true,
          sentElsewhere         : false,
          toEmail               : null,
          toNumber              : null,
          useDefaultCC          : false,
          useDefaultBCC         : false,
          useDefaultFromEmail   : false,
          useDefaultFromNumber  : false,
          useDefaultToEmail     : false,
          useDefaultToNumber    : false
        };
      }
      this.emailTemplateModalForm.openForm(
        MessageTypeText.Alert,
        JSON.parse(JSON.stringify(template!)), 
        this.filterCompanyID!, 
        this.templateReplacements.filter(x => (x.alertTypeId == null || x.alertTypeId == this.selectedAlertTypeId) && (x.alertGroupId == null || x.alertGroupId == this.alertGroupId)),
        this.companyDefaults,
        template?.id as number > 0,
        false,
        true,
        true
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region for Notification Template

  public CanEditNotificationTemplate() : boolean {
    let result = this.alertForm.controls["notificationEnabled"].value && this.templateButtonsEnabled && ((this.selectedNotificationTemplateId ?? 0) > 0);
    return result;
  }

  public notificationTemplateModalFormClosed(event : {TemplateModalAction : TemplateModalAction,TemplateId : number}) {
    try{
      this.templateOpen           = false;
      this.templateButtonsEnabled = false;
      if(event.TemplateModalAction == TemplateModalAction.Save || event.TemplateModalAction == TemplateModalAction.SaveAndEnable){
        this.alertForm.controls["notificationEnabled"].setValue(true);
        this.selectedNotificationTemplateId = event.TemplateId;
        this.getTemplateData(true);
      }else {
        this.templateButtonsEnabled = true;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onNotificationChange(event : Event) : void {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedNotificationTemplateId = Number(selectElement.value);
  }
  public openNotificationTemplate(newTemplate:boolean) : void {
    try {
      this.templateOpen = true;
      this.toggleDropdown('notificationOpen');
      let template;
      if(!newTemplate && this.selectedNotificationTemplateId != undefined){
        template = this.notificationTemplates.find(y => y.id == this.selectedNotificationTemplateId); 
      }
      else{
        template = {
          alertTypeId           : this.selectedAlertTypeId,
          id                    : 0,
          messageTypeId         : MessageType.Alert,
          name                  : null,
          subject               : null,
          body                  : null,
          bcc                   : null,
          cc                    : null,
          fromEmail             : null,
          fromNumber            : null,
          sendToUser            : true,
          sentElsewhere         : false,
          toEmail               : null,
          toNumber              : null,
          useDefaultCC          : false,
          useDefaultBCC         : false,
          useDefaultFromEmail   : false,
          useDefaultFromNumber  : false,
          useDefaultToEmail     : false,
          useDefaultToNumber    : false
        };
      }   
      this.notificationTemplateModalForm.openForm(
        MessageTypeText.Alert,
        JSON.parse(JSON.stringify(template!)), 
        this.filterCompanyID!, 
        this.templateReplacements.filter(x => (x.alertTypeId == null || x.alertTypeId == this.selectedAlertTypeId) && (x.alertGroupId == null || x.alertGroupId == this.alertGroupId)), 
        this.companyDefaults,
        template?.id as number > 0,
        false,
        true,
        true
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region for SMS Template
  public CanEditSMSTemplate() : boolean {
    let result = this.alertForm.controls["smsEnabled"].value && this.templateButtonsEnabled && ((this.selectedSMSTemplateId ?? 0) > 0);
    return result;
  }
  public onSMSChange(event : Event) : void {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedSMSTemplateId = Number(selectElement.value);
  }

  public openSMSTemplate(newTemplate:boolean) : void {
    try {
      this.templateOpen = true;
      this.toggleDropdown('smsOpen');
      let template;
      if(!newTemplate && this.selectedSMSTemplateId != undefined){
        template = this.smsTemplates.find(y => y.id == this.selectedSMSTemplateId); 
      }
      else{
        template = {
          alertTypeId           : this.selectedAlertTypeId,
          id                    : 0,
          messageTypeId         : MessageType.Alert,
          name                  : null,
          subject               : null,
          body                  : null,
          bcc                   : null,
          cc                    : null,
          fromEmail             : null,
          fromNumber            : null,
          sendToUser            : true,
          sentElsewhere         : false,
          toEmail               : null,
          toNumber              : null,
          useDefaultCC          : false,
          useDefaultBCC         : false,
          useDefaultFromEmail   : false,
          useDefaultFromNumber  : false,
          useDefaultToEmail     : false,
          useDefaultToNumber    : false
        };
      }
      this.smsTemplateModalForm.openForm(
        MessageTypeText.Alert,
        JSON.parse(JSON.stringify(template!)), 
        this.filterCompanyID!, 
        this.templateReplacements.filter(x => (x.alertTypeId == null || x.alertTypeId == this.selectedAlertTypeId) && (x.alertGroupId == null || x.alertGroupId == this.alertGroupId)),
        this.companyDefaults,
        template?.id as number > 0,
        false,
        true,
        true
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  //#endregion

  //#region Test Messaging
  public smsTemplateModalFormClosed(event : {TemplateModalAction : TemplateModalAction,TemplateId : number}) {
    try{
      this.templateOpen           = false;
      this.templateButtonsEnabled = false;
      if(event.TemplateModalAction == TemplateModalAction.Save || event.TemplateModalAction == TemplateModalAction.SaveAndEnable){
        this.alertForm.controls["smsEnabled"].setValue(true);
        this.selectedSMSTemplateId = event.TemplateId;
        this.getTemplateData(true);
      } else {
        this.templateButtonsEnabled = true;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public inputModalFormCancelled() {
    try {
      this.templateTestInProgress = false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public inputModalFormSubmitted(inputValue: string) {
    try {
      let selectedSystemValue = this.userSimValues.find(x => x.id == Number(inputValue));
        if(selectedSystemValue){
          if (this.inputModalForm.formTitle == "Select SIM To SMS") {
             this.sendTestSMS(selectedSystemValue.description); 
          } else {
             this.sendTestEmail(selectedSystemValue.description);
          }
        }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public sendTestSMS(sim : string) {
    try {
      let template = undefined;
      if(this.selectedSMSTemplateId != undefined){
        template = this.smsTemplates.find(y => y.id == this.selectedSMSTemplateId); 
      }
      if (template != undefined ) {
        this.templateTestInProgress = true;
  
        this.commConfigsService.SendTestCommunication(template.id, sim, this.curUser.userId)
        .pipe(
          catchError((error) => {
            this.templateTestInProgress = false;
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.templateTestInProgress = false;
            this.processTestMessageComplete("Test SMS Sent");
          },
          error: error => {
            this.templateTestInProgress = false;
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public sendTestSMSGetDetails() {
    try {
      if (!this.templateTestInProgress) {
        this.toggleDropdown('smsOpen');
        this.templateTestInProgress = true;
        if (this.userSimValues.length > 1) {
          this.inputModalForm.fieldCaption                        ="SIM";
          this.inputModalForm.formTitle                           ="Select SIM To SMS";
          this.inputModalForm.input0EnforceMaxLengthValidation    =false;
          this.inputModalForm.input0EnforceMultipleEmailValidation=false;
          this.inputModalForm.input0EnforceRequiredValidation     =true;
          this.inputModalForm.input0Value                         =undefined;
          this.inputModalForm.input0Values                        =this.userSimValues.map(x => ({name:x.description, id:<number>x.id}));;
          this.inputModalForm.openForm();
        } else {
          this.sendTestSMS(this.userSimValues[0].description);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getUsersSims() {
    try {
      this.devicesService.getIdAndDescriptionForUser(this.curUser.userId)
      .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.userSimValues = data;
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private processTestMessageComplete(message : string) {
    try {
      this.DoNotCloseFormOnCompleted=true;
      this.templateTestInProgress   =false;
      this.completedModalForm.openForm("Congratulations", message);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public sendTestEmail(sim : string) {
    try {
      let template = undefined;
      if(this.selectedEmailTemplateId != undefined){
        template = this.emailTemplates.find(y => y.id == this.selectedEmailTemplateId); 
      }
      if (template != undefined ) {
        this.templateTestInProgress = true;
  
        this.commConfigsService.SendTestCommunication(template.id, sim, this.curUser.userId)
        .pipe(
          catchError((error) => {
            this.templateTestInProgress = false;
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.templateTestInProgress = false;
            this.processTestMessageComplete("Test Email Sent");
          },
          error: error => {
            this.templateTestInProgress = false;
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public sendTestEmailGetDetails() {
    try {
      if (!this.templateTestInProgress) {
        this.toggleDropdown('emailOpen');
        this.templateTestInProgress = true;
        if (this.userSimValues.length > 1) {
          this.inputModalForm.fieldCaption                        ="SIM";
          this.inputModalForm.formTitle                           ="Select SIM To Email";
          this.inputModalForm.input0EnforceMaxLengthValidation    =false;
          this.inputModalForm.input0EnforceMultipleEmailValidation=false;
          this.inputModalForm.input0EnforceRequiredValidation     =true;
          this.inputModalForm.input0Value                         =undefined;
          this.inputModalForm.input0Values                        =this.userSimValues.map(x => ({name:x.description, id:<number>x.id}));
          this.inputModalForm.openForm();
        } else {
          this.sendTestEmail(this.userSimValues[0].description);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
